(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["luxe-collection-explorer"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__lceCleanup) {
    try { window.__lceCleanup(); } catch (e) {}
  }
  var __lceCleanupCallbacks = [];
  function _add(target, event, handler, opts) {
    target.addEventListener(event, handler, opts);
    __lceCleanupCallbacks.push(function () {
      target.removeEventListener(event, handler, opts);
    });
  }
  window.__lceCleanup = function () {
    __lceCleanupCallbacks.forEach(function (fn) { try { fn(); } catch (e) {} });
    __lceCleanupCallbacks.length = 0;
  };

  var STORAGE_KEY = 'unlawk-active-collection';
  var EVENT_NAME = 'unlawk-collection-change';

  function getActiveSlug() {
    try { return sessionStorage.getItem(STORAGE_KEY) || ''; } catch (e) { return ''; }
  }
  function setActiveSlug(slug) {
    try { sessionStorage.setItem(STORAGE_KEY, slug); } catch (e) {}
  }

  document.querySelectorAll('.lce').forEach(function (root) {
    var openerEl = root.querySelector('.lce__opener');
    var cards = root.querySelectorAll('.lce__opener-card');
    var pickButtons = root.querySelectorAll('[data-lce-pick]');
    if (cards.length === 0) return;

    // Slugs in source order (left → right)
    var slugs = [];
    cards.forEach(function (card) {
      var s = card.getAttribute('data-lce-card-for');
      if (s) slugs.push(s);
    });
    if (slugs.length === 0) return;

    var initial = getActiveSlug();
    if (slugs.indexOf(initial) === -1) initial = slugs[0];

    function applyActive(slug) {
      // Toggle is-active on each card based on slug match
      cards.forEach(function (card) {
        var isActive = card.getAttribute('data-lce-card-for') === slug;
        card.classList.toggle('is-active', isActive);
      });
      // Set the data attribute on the parent so CSS knows which side is wide.
      // First slug (index 0) = left wide. Second slug = right wide.
      if (openerEl) {
        var idx = slugs.indexOf(slug);
        openerEl.setAttribute('data-lce-active-side', idx === 0 ? 'left' : 'right');
        openerEl.setAttribute('data-lce-active', slug);
      }
    }

    function broadcast(slug) {
      try {
        document.dispatchEvent(new CustomEvent(EVENT_NAME, {
          detail: { slug: slug, source: 'selector' }
        }));
      } catch (e) {}
    }

    function scrollPastSelector(slug) {
      // Wait for downstream sections to mount/reveal, then scroll so:
      //  - The selector sits at the top of the viewport (just below header)
      //  - The new collection's section starts immediately below
      requestAnimationFrame(function () {
        setTimeout(function () {
          var selectorEl = root;
          if (!selectorEl) return;
          var rect = selectorEl.getBoundingClientRect();
          var headerOffset = 80;
          var topbar = document.querySelector('.luxe-header__topbar');
          if (topbar) {
            var h = topbar.getBoundingClientRect().height;
            if (h > 20) headerOffset = h;
          }
          var targetY = rect.top + window.pageYOffset - headerOffset;
          if (targetY < 0) targetY = 0;

          if (window.lenis && typeof window.lenis.scrollTo === 'function') {
            try {
              window.lenis.scrollTo(targetY, { duration: 0.9, lock: false, force: true });
              return;
            } catch (err) {}
          }
          window.scrollTo({ top: targetY, behavior: 'smooth' });
        }, 80);
      });
    }

    function switchCollection(slug, opts) {
      if (slugs.indexOf(slug) === -1) return;
      setActiveSlug(slug);
      applyActive(slug);
      broadcast(slug);
      // Only scroll when explicitly requested. Switching collections via the
      // peek cards does NOT scroll — user is already looking at the selector.
      if (opts && opts.scroll) {
        scrollPastSelector(slug);
      }
    }

    // Initial state
    applyActive(initial);
    // Always broadcast on mount so downstream sections sync
    broadcast(initial);

    // Listen for external changes (e.g. header collection links)
    _add(document, EVENT_NAME, function (e) {
      if (!e.detail || !e.detail.slug) return;
      if (e.detail.source === 'selector') return;
      applyActive(e.detail.slug);
      setActiveSlug(e.detail.slug);
      // Honor an explicit scroll request from the dispatcher (e.g. header link click)
      if (e.detail.scroll) {
        scrollPastSelector(e.detail.slug);
      }
    });

    // Wire up peek cards — switch the selected collection but stay put.
    // User is already looking at the selector; scrolling would feel jarring.
    pickButtons.forEach(function (btn) {
      _add(btn, 'click', function (e) {
        e.preventDefault();
        var slug = btn.getAttribute('data-lce-pick');
        if (slug) switchCollection(slug);
      });
    });

    // === Cross-page entry: handle URL hash ===
    // Header links like /#collection-original or /#collection-divine-protectors
    // jump to this section AND force the right collection active. Without this,
    // the explorer's stored sessionStorage value would override what the user
    // just clicked, sending them to the wrong collection.
    function handleHash() {
      var h = window.location.hash || '';
      var match = h.match(/^#collection-(.+)$/);
      if (!match) return;
      var requested = match[1];
      if (slugs.indexOf(requested) === -1) return;
      // Strip hash immediately so browser native anchor-scroll doesn't fight us
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', window.location.pathname + window.location.search);
      }
      // CROSS-PAGE NAV ONLY: release the luxe-experience barriers so our scroll
      // can land on the selector instead of being clamped back to the hero.
      // (This release does NOT happen on regular page loads or peek-card clicks.)
      try {
        window.__skipIntro = true;
        window.__boomGateOpen = true;
        window.__boomReady = true;
        window.__carouselGateOpen = true;
        window.__carouselReady = true;
        window.__boomTriggered = true;
        if (!window.__boomStartTime) {
          window.__boomStartTime = performance.now() - 5000;
        }
      } catch (e) {}
      switchCollection(requested, { scroll: true });
    }
    // Run on page load
    handleHash();
    // Run on hashchange (in case user clicks the same link twice)
    _add(window, 'hashchange', handleHash);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxe-coming-soon"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__lcsCleanup) {
    try { window.__lcsCleanup(); } catch (e) {}
  }
  var __lcsCleanupCallbacks = [];
  function _add(target, event, handler, opts) {
    target.addEventListener(event, handler, opts);
    __lcsCleanupCallbacks.push(function () {
      target.removeEventListener(event, handler, opts);
    });
  }
  window.__lcsCleanup = function () {
    __lcsCleanupCallbacks.forEach(function (fn) { try { fn(); } catch (e) {} });
    __lcsCleanupCallbacks.length = 0;
  };

  var STORAGE_KEY = 'unlawk-active-collection';
  var EVENT_NAME = 'unlawk-collection-change';

  document.querySelectorAll('.lcs').forEach(function (root) {
    var targetSlug = root.getAttribute('data-lcs-target-collection') || 'divine';

    function applyVisibility(slug) {
      if (root.hasAttribute('data-lcs-always')) { root.removeAttribute('hidden'); return; }
      if (slug === targetSlug) {
        root.removeAttribute('hidden');
      } else {
        root.setAttribute('hidden', '');
      }
    }

    // Initial state. Three sources, in priority order:
    //   1. sessionStorage (set by previous interactions)
    //   2. Currently-visible opener view in the selector section (DOM check)
    //   3. Fallback: hidden (assume we don't match)
    var initial = '';
    try { initial = sessionStorage.getItem(STORAGE_KEY) || ''; } catch (e) {}
    if (initial === '') {
      // First try the new opener container's data-lce-active attribute
      var openerEl = document.querySelector('.lce__opener[data-lce-active]');
      if (openerEl) {
        initial = openerEl.getAttribute('data-lce-active') || '';
      }
      // Legacy fallback for old markup
      if (initial === '') {
        var visibleOpener = document.querySelector('.lce__opener-view:not([hidden])');
        if (visibleOpener) {
          initial = visibleOpener.getAttribute('data-lce-opener-for') || '';
        }
      }
    }
    applyVisibility(initial);

    _add(document, EVENT_NAME, function (e) {
      if (!e.detail || !e.detail.slug) return;
      applyVisibility(e.detail.slug);
    });

    // ============================================================
    // SCROLL-TILT for cells (mirrors OG luxe-experience flip-tilt)
    // ============================================================
    var flipSections = Array.prototype.slice.call(root.querySelectorAll('.lcs-flip-section'));

    function updateFlipTilts() {
      if (root.hasAttribute('hidden')) return;
      var wh = window.innerHeight;
      var isPhone = window.innerWidth < 768;
      var PLATEAU = isPhone ? 0.04 : 0.18;
      var MAX_ROT = isPhone ? 75 : 45;
      flipSections.forEach(function (s) {
        var r = s.getBoundingClientRect();
        var inner = s.querySelector('.lcs-flip-inner');
        if (!inner) return;
        if (r.bottom < -wh * 0.3 || r.top > wh * 1.3) {
          inner.style.setProperty('--lcs-flip-rot', '0deg');
          return;
        }
        var sectionCenter = r.top + r.height / 2;
        var viewportCenter = wh / 2;
        var offset = (sectionCenter - viewportCenter) / wh;
        var clamped = Math.max(-1.2, Math.min(1.2, offset));
        var absOffset = Math.abs(clamped);
        var rot;
        if (absOffset < PLATEAU) {
          rot = 0;
        } else {
          var beyond = (absOffset - PLATEAU) / (1.2 - PLATEAU);
          var eased = beyond < 0.5
            ? 2 * beyond * beyond
            : 1 - Math.pow(-2 * beyond + 2, 2) / 2;
          rot = Math.sign(clamped) * eased * MAX_ROT;
        }
        inner.style.setProperty('--lcs-flip-rot', rot.toFixed(1) + 'deg');
      });
    }

    var ticking = false;
    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(function () { updateFlipTilts(); ticking = false; });
        ticking = true;
      }
    }
    _add(window, 'scroll', onScroll, { passive: true });
    _add(window, 'resize', onScroll, { passive: true });
    updateFlipTilts();

    // ============================================================
    // INTERSECTION OBSERVER — fade in cell content when visible
    // ============================================================
    var cells = root.querySelectorAll('.lcs-cell');
    if (cells.length > 0 && 'IntersectionObserver' in window) {
      var cellObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) e.target.classList.add('is-visible');
        });
      }, { threshold: 0.25, rootMargin: '0px 0px -10% 0px' });
      cells.forEach(function (c) { cellObserver.observe(c); });
      __lcsCleanupCallbacks.push(function () { cellObserver.disconnect(); });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxe-divine-protector"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('form[data-ldp-klaviyo]').forEach(function (form) {
      if (form.dataset.ldpBound === 'true') return;
      form.dataset.ldpBound = 'true';

      form.addEventListener('submit', async function (e) {
        e.preventDefault();
        const listId = form.dataset.ldpKlaviyoList;
        const successMsg = form.dataset.ldpSuccessMsg || 'On the list ✓';
        const emailInput = form.querySelector('input[name="email"]');
        const btn = form.querySelector('button[type="submit"]');
        const feedback = form.querySelector('.luxe-dp__notify-feedback');
        if (!listId || !emailInput || !feedback) return;

        const email = (emailInput.value || '').trim();
        if (!email) {
          feedback.textContent = 'Please enter an email address.';
          feedback.className = 'luxe-dp__notify-feedback luxe-dp__notify-feedback--error';
          return;
        }

        const originalLabel = btn.querySelector('span') ? btn.querySelector('span').textContent : btn.textContent;
        if (btn.querySelector('span')) btn.querySelector('span').textContent = 'Sending…';
        btn.disabled = true;

        try {
          const body = new URLSearchParams();
          body.append('g', listId);
          body.append('email', email);
          body.append('$fields', 'email');
          await fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
            method: 'POST',
            mode: 'no-cors',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: body
          });
          feedback.textContent = successMsg;
          feedback.className = 'luxe-dp__notify-feedback luxe-dp__notify-feedback--success';
          emailInput.value = '';
          // After 2.5s of seeing the thank-you, hard-reload the page from the top
          // so the user experiences the full website again from scratch — manifesto,
          // explosion, the whole journey. Hard reload guarantees state reset.
          setTimeout(function () {
            // Set scroll to 0 first so the reload starts at top.
            if ('scrollRestoration' in history) {
              try { history.scrollRestoration = 'manual'; } catch (e) {}
            }
            window.scrollTo(0, 0);
            // Hard reload — bypasses cache, resets all JS state.
            window.location.href = '/';
          }, 2500);
        } catch (err) {
          feedback.textContent = 'Something went wrong. Please try again.';
          feedback.className = 'luxe-dp__notify-feedback luxe-dp__notify-feedback--error';
        } finally {
          if (btn.querySelector('span')) btn.querySelector('span').textContent = originalLabel;
          btn.disabled = false;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxe-experience"] && !Shopify.designMode) return;
  try {
    
(function () {

  // === Cleanup any previous instance of this section's JS ===
  // Shopify theme editor reloads sections on every settings change, but doesn't
  // clean up our event listeners or rAF loops. Without this, memory accumulates
  // until the editor crashes. Each new instance disposes the old one first.
  if (window.__luxeExperienceCleanup) {
    try { window.__luxeExperienceCleanup(); } catch (e) { /* noop */ }
  }
  const __cleanupCallbacks = [];
  window.__luxeExperienceCleanup = function () {
    __cleanupCallbacks.forEach(cb => { try { cb(); } catch (e) {} });
    __cleanupCallbacks.length = 0;
  };
  // Helper: register cleanup-aware listeners
  function _addListener(target, event, fn, opts) {
    target.addEventListener(event, fn, opts);
    __cleanupCallbacks.push(() => target.removeEventListener(event, fn, opts));
  }
  function _addRAF(loop) {
    let id = requestAnimationFrame(loop);
    __cleanupCallbacks.push(() => cancelAnimationFrame(id));
    return () => cancelAnimationFrame(id);
  }

  // === Reset listener — header brand mark click broadcasts 'luxe:reset' ===
  // When fired, undo all constellation/manifesto state so the experience can be
  // re-watched without a page reload.
  _addListener(window, 'luxe:reset', () => {
    try {
      // Clear any timers that may be queued
      if (window.__boomGateTimer) clearTimeout(window.__boomGateTimer);
      if (window.__carouselGateTimer) clearTimeout(window.__carouselGateTimer);
      if (window.__autoScrollTimer) clearTimeout(window.__autoScrollTimer);
      // Reset all gate flags
      window.__boomGateOpen = false;
      window.__boomReady = false;
      window.__boomTriggered = false;
      window.__carouselGateOpen = false;
      window.__carouselReady = false;
      window.__autoScrollAfterDive = false;
      window.__manifestoRevealed = false;
      window.__manifestoComplete = false;
      window.__chargeStartTime = null;
      window.__reverseScrolling = false;
      // Reset visual state on key elements
      const manifestoText = document.getElementById('manifestoText');
      if (manifestoText) {
        manifestoText.classList.remove('is-boomed');
        manifestoText.querySelectorAll('.manifesto__word, .word').forEach(w => {
          w.classList.remove('is-lit', 'lit', 'flash');
        });
      }
      const stage = document.getElementById('constellationStage');
      if (stage) stage.classList.remove('is-boom', 'is-carousel', 'is-dive');
      const orbs = document.querySelectorAll('.orb');
      orbs.forEach(orb => {
        orb.style.transform = '';
        orb.style.opacity = '';
      });
    } catch (err) { console.warn('luxe:reset error', err); }
  });

  // === Cell click navigation — bulletproof + smooth fade-out ===
  // The cell has a native <a class="cell__link"> wrapping it for SEO, right-click,
  // and middle-click behavior. But on mobile (and during 3D rotation), other
  // handlers on the page can intercept the click and prevent navigation.
  //
  // Solution: a capture-phase click handler on .cell that runs BEFORE any other
  // listener can interfere. We aggressively claim the click with
  // stopImmediatePropagation + preventDefault, then navigate manually and
  // immediately. The page fade is handled natively by the cross-document view
  // transition (snippets/luxe-view-transitions.liquid) — no artificial delay.
  document.querySelectorAll('.cell').forEach(cell => {
    const link = cell.querySelector('.cell__link');
    if (!link) return;
    const href = link.getAttribute('href');
    // Bail if no real URL is set — nothing to navigate to
    if (!href || href === '#' || href === '/' || href.trim() === '') {
      cell.style.cursor = 'default';
      return;
    }
    const navigate = (e) => {
      // Allow clicks on interactive children — they should do their own thing
      if (e.target.closest('.cell__variants, .cell__variant, button')) return;
      // Modifier keys → respect browser defaults (Cmd-click → new tab, etc.)
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || (e.button !== undefined && e.button !== 0)) return;
      // Claim the click — beat any other handler on the page
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      window.location.href = href;
    };
    // Capture phase: runs BEFORE bubble-phase handlers
    _addListener(cell, 'click', navigate, { capture: true });
  });

// === CONSTELLATION + MANIFESTO MERGED — scroll-pinned 5-beat reveal ===
  const constellation = document.getElementById('constellation');
  const orbs = constellation ? Array.from(constellation.querySelectorAll('.orb')) : [];
  const cMark = document.getElementById('constellationMark');
  const cShockwave = document.getElementById('constellationShockwave');
  const cGate = document.getElementById('constellationGate');
  const cRail = document.getElementById('constellationRail');
  const cManifesto = document.getElementById('constellationManifesto');
  const cManifestoEyebrow = document.getElementById('manifestoEyebrow');
  const cManifestoText = document.getElementById('manifestoText');
  const N = orbs.length; // 12

  // === Skip-intro state (returning user in same session) ===
  // Header inline script set window.__skipIntro based on sessionStorage + nav type.
  // When true: pre-fire all intro phases so orb math jumps straight to carousel state.
  if (window.__skipIntro) {
    window.__boomTriggered = true;
    window.__boomStartTime = performance.now() - 3000;  // BOOM "happened" 3s ago, autoplay long done
    window.__boomGateOpen = true;
    window.__boomReady = true;
    window.__carouselGateOpen = true;
    window.__carouselReady = true;
    window.__manifestoRevealed = true;
    window.__manifestoComplete = true;
    // Hide manifesto so it doesn't reveal if user scrolls back up to top of section
    if (cManifesto) cManifesto.style.opacity = '0';
    if (cMark) cMark.style.opacity = '0';
    // Light up all manifesto words (so if user does scroll up, they see fully-lit text)
    setTimeout(() => {
      document.querySelectorAll('.manifesto .word').forEach(w => w.classList.add('lit'));
    }, 0);
  }

  // === Set up manifesto word spans ===
  // Walk the DOM directly instead of regex-replacing innerHTML strings, which
  // is brittle and was causing __EM__0__ placeholders to leak through. For each
  // child node:
  //   - text node → split into words, wrap each in <span class="word">
  //   - <em> element → recurse into it, then wrap with em tag preserved
  //   - <br> → leave alone
  let manifestoWords = [];
  if (cManifestoText) {
    function wrapTextInWords(text) {
      // Split by whitespace, wrap each non-empty token in <span class="word">,
      // preserve whitespace between words.
      return text.split(/(\s+)/).map(part => {
        if (part === '') return '';
        if (/^\s+$/.test(part)) return part;  // pure whitespace → preserved
        return '<span class="word">' + part + '</span>';
      }).join('');
    }
    function processNode(node) {
      const out = [];
      for (const child of Array.from(node.childNodes)) {
        if (child.nodeType === 3) {
          // Text node — split into words
          out.push(wrapTextInWords(child.textContent));
        } else if (child.nodeType === 1) {
          // Element node
          const tag = child.tagName.toLowerCase();
          if (tag === 'br') {
            out.push('<br>');
          } else if (tag === 'em') {
            // Recursively wrap words inside the em
            out.push('<em>' + processNode(child) + '</em>');
          } else {
            // Other element — preserve as-is with inner content processed
            out.push('<' + tag + '>' + processNode(child) + '</' + tag + '>');
          }
        }
      }
      return out.join('');
    }
    cManifestoText.innerHTML = processNode(cManifestoText);
    manifestoWords = cManifestoText.querySelectorAll('.word');
    // Detect which words are AFTER the <br> tag — they belong to line 2.
    // We'll add an extra reading-pause delay to all line-2 words during reveal.
    window.__manifestoLineBreakIndex = -1;
    const brEl = cManifestoText.querySelector('br');
    if (brEl) {
      for (let i = 0; i < manifestoWords.length; i++) {
        // Node.DOCUMENT_POSITION_FOLLOWING (4) means the compared node comes AFTER the reference.
        if (brEl.compareDocumentPosition(manifestoWords[i]) & 4) {
          window.__manifestoLineBreakIndex = i;
          break;
        }
      }
    }
  }

  // === Compute final orbital positions in 3D (galaxy layout) ===
  // Inner ring 5 orbs, outer ring 7 orbs. Pushed wide to use viewport corners.
  // Use vw/vh-based scaling at runtime
  function computeFinalPositions() {
    const isMobile = window.innerWidth < 900;
    const isPhone = window.innerWidth < 768;
    // Desktop/tablet: wide horizontal galaxy. Phone: portrait galaxy — flip the
    // axes so Y is the bigger dimension (since phones are taller than wide).
    let innerRX, innerRY, outerRX, outerRY;
    if (isPhone) {
      // Portrait phone — galaxy is taller than wide. Pushed wider so orbs don't overlap.
      innerRX = 110;  innerRY = 170;
      outerRX = 175;  outerRY = 340;
    } else if (isMobile) {
      // Tablet
      innerRX = 130;  innerRY = 95;
      outerRX = 240;  outerRY = 185;
    } else {
      // Desktop
      innerRX = 360;  innerRY = 230;
      outerRX = 720;  outerRY = 380;
    }

    return orbs.map((_, i) => {
      const ringInner = i < 5;
      const startAngle = ringInner ? -Math.PI/2 : -Math.PI/2 + Math.PI/7;
      const ringSize = ringInner ? 5 : 7;
      const ringIdx = ringInner ? i : i - 5;
      const angle = startAngle + (ringIdx / ringSize) * Math.PI * 2;
      const rx = ringInner ? innerRX : outerRX;
      const ry = ringInner ? innerRY : outerRY;
      // Vary depth
      const z = ringInner ? 30 + Math.sin(angle * 1.7) * 40 : -40 + Math.sin(angle * 1.3) * 60;
      return {
        x: Math.cos(angle) * rx,
        y: Math.sin(angle) * ry,
        z: z,
        ringInner: ringInner
      };
    });
  }
  let finalPositions = computeFinalPositions();
  _addListener(window, 'resize', () => { finalPositions = computeFinalPositions(); });

  // Drift parameters per orb — gentle bob/sway in final state
  const driftParams = orbs.map(() => ({
    // Vertical bob — taller amplitude, slow rhythm
    bobAmp: 12 + Math.random() * 8,
    bobSpeed: 0.16 + Math.random() * 0.20,
    bobOffset: Math.random() * Math.PI * 2,
    // Horizontal sway — softer
    swayAmp: 7 + Math.random() * 6,
    swaySpeed: 0.12 + Math.random() * 0.15,
    swayOffset: Math.random() * Math.PI * 2,
    // Circular orbital motion — small ellipse around final position
    orbitRadius: 8 + Math.random() * 8,
    orbitSpeed: 0.15 + Math.random() * 0.18,
    orbitOffset: Math.random() * Math.PI * 2,
    orbitDir: Math.random() < 0.5 ? 1 : -1,
    // NEW: gentle scale breathing — orb slightly grows/shrinks (no overlap risk)
    scaleSpeed: 0.18 + Math.random() * 0.15,
    scaleOffset: Math.random() * Math.PI * 2,
    // NEW: subtle rotation — barely perceptible tilt, adds liveness without overlap
    rotSpeed: 0.10 + Math.random() * 0.10,
    rotOffset: Math.random() * Math.PI * 2,
  }));

  let driftStart = performance.now();

  function easeInOutCubic(t) {
    return t < 0.5 ? 4*t*t*t : 1 - Math.pow(-2*t + 2, 3) / 2;
  }
  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }
  function easeInCubic(t) {
    return t * t * t;
  }

  function updateConstellation() {
    if (!constellation || !orbs.length) return;

    const rect = constellation.getBoundingClientRect();
    const wh = window.innerHeight;
    const totalScroll = constellation.offsetHeight - wh;
    if (totalScroll <= 0) return;

    let progress = -rect.top / totalScroll;
    progress = Math.max(0, Math.min(1, progress));

    if (rect.bottom < 0 || rect.top > wh) return;

    // === BEAT TIMELINE ===
    // Beat 1: 0.00 - 0.12   Manifesto reveals over giant brand mark
    // Beat 2: 0.12 - 0.22   Manifesto fades, Healer emerges large
    // Beat 3: 0.22 - 0.62   Galaxy unfolds (other 11 orbs burst out, Healer to slot)
    // Beat 4: 0.62 - 0.92   Locked + drift
    // Beat 5: 0.92 - 1.00   Convergence + dive

    const t = performance.now();
    const driftT = (t - driftStart) / 1000;

    // === Manifesto eyebrow + text ===
    if (cManifesto) {
      let mtextOp = 0;
      let mebrowOp = 0;
      let mtextY = 0;

      if (!window.__boomTriggered) {
        // PRE-BOOM: manifesto stays fully visible regardless of scroll position.
        // Animation continues autonomously while user is locked at scroll barrier.
        mtextOp = 1;
        if (progress < 0.10) {
          // Beat 1 entry: eyebrow fades in fast, text rises into place with scroll feedback
          const b1 = progress / 0.10;
          mebrowOp = easeOutCubic(Math.min(1, b1 * 1.5));
          mtextY = 20 * (1 - easeOutCubic(b1));
        } else {
          // Past Beat 1: hold visible. Don't fade based on scroll — wait for BOOM event.
          mebrowOp = 1;
          mtextY = 0;
        }
      } else {
        // POST-BOOM: fade out over 0.5s of real time (decoupled from scroll)
        const elapsed = (performance.now() - window.__boomStartTime) / 1000;
        const FADE_DURATION = 0.5;
        const fadeP = Math.min(1, elapsed / FADE_DURATION);
        mtextOp = 1 - easeInCubic(fadeP);
        mebrowOp = 1 - easeInCubic(fadeP);
        mtextY = 0;
      }

      cManifesto.style.setProperty('--mtext-opacity', mtextOp.toFixed(2));
      cManifesto.style.setProperty('--mebrow-opacity', mebrowOp.toFixed(2));
      cManifesto.style.setProperty('--mtext-y', mtextY.toFixed(0) + 'px');
    }

    // === Manifesto words light up — split path: desktop uses setTimeout chain,
    //     mobile uses gesture-accelerated rAF progress var (handler below). ===
    const isMobileManifesto = window.matchMedia('(max-width: 768px)').matches;
    if (manifestoWords.length && progress > 0.005 && !window.__manifestoRevealed && !isMobileManifesto) {
      window.__manifestoRevealed = true;
      const PER_WORD_MS = 110;
      const READING_PAUSE_MS = 700;
      const lineBreakIdx = window.__manifestoLineBreakIndex;
      manifestoWords.forEach((w, i) => {
        let delay = i * PER_WORD_MS;
        if (lineBreakIdx !== -1 && i >= lineBreakIdx) {
          delay += READING_PAUSE_MS;
        }
        setTimeout(() => {
          w.classList.add('lit');
          const isEm = w.parentElement && w.parentElement.tagName === 'EM';
          if (!isEm) {
            w.classList.add('flash');
            setTimeout(() => w.classList.remove('flash'), 600);
          }
          if (i === manifestoWords.length - 1) {
            setTimeout(() => {
              window.__manifestoComplete = true;
              window.__chargeStartTime = performance.now();
              setTimeout(() => {
                if (lenis && cachedBoomBarrier !== null) {
                  lenis.scrollTo(cachedBoomBarrier, { immediate: true });
                }
                window.__boomGateOpen = true;
                window.__boomReady = true;
              }, 1500);
            }, 1500);
          }
        }, delay);
      });
    }

    // === MOBILE: gesture-accelerated manifesto progress ===
    // Drives a continuous progress value 0 → 1 that lights words at thresholds.
    // Auto-increments at baseline rate; downward scroll input boosts it.
    if (isMobileManifesto && manifestoWords.length && constellation) {
      // Initialize once
      if (typeof window.__manifestoP !== 'number') {
        window.__manifestoP = 0;
        window.__manifestoLitCount = 0;
        window.__manifestoP_lastProgress = progress;
      }
      const rect = constellation.getBoundingClientRect();
      const sectionVisible = rect.top < window.innerHeight && rect.bottom > 0;
      if (sectionVisible && progress > 0.005 && window.__manifestoP < 1) {
        // Baseline auto-advance ~ finishes in ~5s at 60fps
        let increment = 1 / 300;
        // Scroll-down boost: each unit of progress increase adds extra
        const scrollDelta = progress - (window.__manifestoP_lastProgress || progress);
        if (scrollDelta > 0) {
          increment += Math.min(0.08, scrollDelta * 8);
        }
        window.__manifestoP_lastProgress = progress;
        window.__manifestoP = Math.min(1, window.__manifestoP + increment);

        // Light words at thresholds. First 0.85 of progress reveals all words;
        // last 0.15 is the awareness-grow + logo-glow hold beat.
        const targetLit = Math.floor((window.__manifestoP / 0.85) * manifestoWords.length);
        while (window.__manifestoLitCount < targetLit && window.__manifestoLitCount < manifestoWords.length) {
          const w = manifestoWords[window.__manifestoLitCount];
          if (w) {
            w.classList.add('lit');
            const isEm = w.parentElement && w.parentElement.tagName === 'EM';
            if (!isEm) {
              w.classList.add('flash');
              setTimeout((wRef) => wRef.classList.remove('flash'), 600, w);
            }
          }
          window.__manifestoLitCount++;
        }

        // When manifesto progress hits 1, transition to building state
        if (window.__manifestoP >= 1 && !window.__manifestoComplete) {
          manifestoWords.forEach((w) => w.classList.add('lit'));
          window.__manifestoComplete = true;
          window.__manifestoRevealed = true;
          window.__chargeStartTime = performance.now();
          window.__boomGateOpen = true;
          window.__boomReady = true;
          window.__mobileBuildState = 'building';
          window.__mobileCardCount = orbs.length;
          try { sessionStorage.setItem('luxe-intro-played', '1'); } catch (e) {}
        }
      }
    }

    // Reset trigger if user scrolls back fully above the section
    if (progress < 0.001) {
      // Don't auto-reset — keep words lit even on scroll back; only reset on full page reload
    }

    // === Brand mark — fully event-driven, decoupled from scroll position ===
    if (cMark) {
      let markOp = 0.07;
      let markScale = 1;
      let markGlow = 0;
      let shakeX = 0, shakeY = 0;

      const manifestoComplete = !!window.__manifestoComplete;
      const isMobileMark = window.matchMedia('(max-width: 768px)').matches;

      if (isMobileMark) {
        // === MOBILE: no shake, no BOOM. Logo stays calm, glows when awareness peaks. ===
        if (!manifestoComplete) {
          // Pre-manifesto-complete: gentle scale ramp during reading
          if (progress < 0.10) {
            const b1 = progress / 0.10;
            markScale = 0.92 + easeOutCubic(b1) * 0.08;
          } else {
            markScale = 1.0;
          }
          markOp = 0.07;
          markGlow = 0;
        } else {
          // Manifesto complete: glow synced with "awareness" grow animation (3.5s).
          // chargeStartTime fires same moment awareness starts growing. Use that as t=0.
          const elapsed = window.__chargeStartTime
            ? (performance.now() - window.__chargeStartTime) / 1000
            : 0;
          const GLOW_DURATION = 3.5;  // matches awareness grow CSS transition
          const t = Math.min(1, elapsed / GLOW_DURATION);
          // Sine bell curve: rise from 0 → peak at t=0.5 → fall back to 0
          const bell = Math.sin(t * Math.PI);
          markScale = 1.0 + bell * 0.06;          // very subtle pulse
          markOp = 0.07 + bell * 0.10;             // 0.07 → 0.17 → 0.07
          markGlow = bell * 36;                    // 0 → 36px → 0
          // After 3.5s, glow has fully decayed; logo settles to quiet baseline.
          if (elapsed > GLOW_DURATION) {
            markScale = 1.0;
            markOp = 0.05;   // quieter background presence during build/cylinder phase
            markGlow = 0;
          }
        }
      } else if (!window.__boomTriggered) {
        // === DESKTOP — original behavior, untouched ===
        if (!manifestoComplete) {
          if (progress < 0.10) {
            const b1 = progress / 0.10;
            markScale = 0.92 + easeOutCubic(b1) * 0.08;
          } else {
            markScale = 1.0;
          }
          markOp = 0.07;
          markGlow = 0;
        } else {
          const chargeElapsed = window.__chargeStartTime
            ? (performance.now() - window.__chargeStartTime) / 1000
            : 0;
          const chargeIntensity = Math.min(1, chargeElapsed / 0.8);
          markScale = 1.0 + chargeIntensity * 0.18;
          markOp = 0.07 + chargeIntensity * 0.48;
          markGlow = chargeIntensity * 30;
          const t = performance.now() * 0.001;
          const shakeAmp = chargeIntensity * 7;
          shakeX = Math.sin(t * 90 * Math.PI) * shakeAmp;
          shakeY = Math.cos(t * 70 * Math.PI) * shakeAmp;
        }
      } else if (progress < 0.78) {
        // Desktop POST-BOOM
        const after = Math.min(1, (performance.now() - window.__boomStartTime) / 800);
        const afterEased = easeOutCubic(after);
        markScale = 1.18 - afterEased * 0.18;
        markOp = 0.55 - afterEased * 0.42;
        markGlow = 30 * (1 - afterEased);
      } else {
        // Desktop dive
        const b5 = (progress - 0.78) / 0.22;
        markOp = 0.13 - easeInCubic(b5) * 0.13;
      }

      cMark.style.setProperty('--mark-opacity', markOp.toFixed(3));
      cMark.style.setProperty('--mark-scale', markScale.toFixed(3));
      cMark.style.setProperty('--mark-glow', markGlow.toFixed(0) + 'px');
      cMark.style.setProperty('--mark-shake-x', shakeX.toFixed(1) + 'px');
      cMark.style.setProperty('--mark-shake-y', shakeY.toFixed(1) + 'px');
    }

    // === Gate text position — center during galaxy phase (visible above orbs),
    // bottom during carousel phase (front cards otherwise cover center). Triggered
    // by __carouselReady (the second scroll input that unlocks the carousel barrier). ===
    if (cGate) {
      cGate.classList.toggle('is-bottom', !!window.__carouselReady);
    }

    // === Shockwave — gold ring that bursts outward at BOOM moment, time-driven ===
    if (cShockwave) {
      let swScale = 0;
      let swOpacity = 0;
      if (window.__boomTriggered) {
        const swElapsed = (performance.now() - window.__boomStartTime) / 1000;  // seconds
        const SHOCKWAVE_DURATION = 0.6;  // 0.6 second flash
        if (swElapsed < SHOCKWAVE_DURATION) {
          const swP = swElapsed / SHOCKWAVE_DURATION;
          const swEased = easeOutCubic(swP);
          swScale = swEased * 28;
          swOpacity = (1 - swEased) * (swP < 0.1 ? swP * 10 : 1);
        }
      }
      cShockwave.style.setProperty('--shockwave-scale', swScale.toFixed(2));
      cShockwave.style.setProperty('--shockwave-opacity', swOpacity.toFixed(2));
    }

    // === BOOM trigger ===
    // DESKTOP: BOOM fires the orb explosion. MOBILE: this branch is skipped entirely;
    // mobile uses a separate state machine (__mobileBuildState) that's driven by
    // discrete swipe gestures, not by scroll progress / BOOM auto-play.
    const isMobileViewport = window.matchMedia('(max-width: 768px)').matches;
    if (progress > 0.143 && !window.__boomTriggered && window.__boomGateOpen && window.__boomReady && !isMobileViewport) {
      window.__boomTriggered = true;
      window.__boomStartTime = performance.now();
      try { sessionStorage.setItem('luxe-intro-played', '1'); } catch (e) {}
      if (cManifestoText) cManifestoText.classList.add('is-boomed');
      window.__carouselGateOpen = true;
      // Show rail in HOLD state — desktop briefly, then transitions to swipe hint
      if (cRail) {
        cRail.classList.add('is-holding');
        cRail.classList.remove('is-swipe', 'is-engaged');
      }
      // DESKTOP: do NOT pre-open the carousel gate. The user must reach the
      // carousel barrier (~progress 0.30), pause briefly, then resume scrolling
      // for the morph into the cylinder to begin. This makes the galaxy/orbit
      // hover feel like an intentional rest beat — not a frame the user blows past.
      // window.__carouselReady stays false; the scroll gate auto-release loop
      // will set it to true after CAROUSEL_GATE_PAUSE_MS at the barrier.
      // Transition rail: hold → swipe (after a brief beat so user notices the hold first)
      setTimeout(() => {
        if (cRail) {
          cRail.classList.remove('is-holding');
          cRail.classList.add('is-swipe');
        }
      }, 1200);
    }

    // === MOBILE build state machine (replaces BOOM/galaxy/morph on mobile) ===
    // States:
    //   'idle'      — initial, manifesto reading. No cards visible.
    //   'building'  — logo turn done, cards spawning one-by-one with each swipe.
    //   'complete'  — all 12 cards in cylinder, free-spin mode.
    // Returning users (skipIntro): start directly in 'complete' with all cards rendered.
    if (isMobileViewport && !window.__mobileBuildState) {
      if (window.__skipIntro) {
        window.__mobileBuildState = 'complete';
        window.__mobileCardCount = 12;
        window.__cylinderSpinTarget = 0;     // current spin offset (radians)
        window.__cylinderSpinCurrent = 0;    // smoothed spin value
      } else {
        window.__mobileBuildState = 'idle';
        window.__mobileCardCount = 0;
        window.__cylinderSpinTarget = 0;
        window.__cylinderSpinCurrent = 0;
      }
    }

    // Desktop gate: appears when scroll progress crosses past TRANSITION_END (carousel visible).
    // Mobile gate is opened by the timeout above when scroll lock releases.
    if (cGate && progress >= 0.36 && !cGate.classList.contains('is-open') && window.__carouselReady && !window.matchMedia('(max-width: 768px)').matches) {
      cGate.classList.add('is-open');
    }
    // Once user starts scrolling within carousel range, fade gate AND rail swipe to softer state.
    if (cGate && cGate.classList.contains('is-open') && !cGate.classList.contains('is-engaged')) {
      const idleSinceScroll = performance.now() - (window.__lastUserScrollTime || 0);
      if (idleSinceScroll < 200 && progress > 0.40) {
        cGate.classList.add('is-engaged');
        if (cRail) cRail.classList.add('is-engaged');
      }
    }
    const boomTriggered = !!window.__boomTriggered;
    const BOOM_DURATION = 1500;  // ms — how long the orb burst auto-play takes
    let autoplayProgress = 0;
    if (boomTriggered) {
      autoplayProgress = Math.min(1, (performance.now() - window.__boomStartTime) / BOOM_DURATION);
    }
    // Effective expansion progress: 1 once auto-play complete & past threshold; scroll-driven if user scrolled back
    let effExpand;
    if (!boomTriggered) {
      effExpand = 0;
    } else if (progress >= 0.14) {
      effExpand = autoplayProgress;
    } else {
      // User scrolled back below threshold — reverse via scroll, capped by autoplay state
      const scrollDriven = Math.max(0, progress) / 0.14;
      effExpand = Math.min(autoplayProgress, scrollDriven);
    }
    // Auto-play in progress (still flying outward)
    const autoplayInProgress = boomTriggered && autoplayProgress < 1;

    // === Choreography ===
    // 0.14: BOOM trigger
    // 0.14-~0.20: BOOM autoplay (1.5s real-time) → orbs explode to GALAXY formation
    // 0.20-0.30: GALAXY HOVER (10%) — orbs orbit/drift in galaxy
    // 0.30-0.36: TRANSITION (6%, quick) — galaxy → cylinder positions, rotateY ramps up
    // 0.36-0.78: 3D CAROUSEL (42%, "swipe pretty quick") — cylinder rotates 360° with cards facing outward
    // 0.78-1.00: DIVE (22%, fade away)
    const GALAXY_HOVER_END = 0.30;
    const TRANSITION_END = 0.36;
    const CAROUSEL_END = 0.78;
    const DIVE_START = 0.78;

    // === Shared auto-dive function ===
    // Bulletproof scroll into cell-01: blocks user input + position-pins on every frame
    // so the screen RELIABLY follows the cards down. Used by both the early trigger
    // (carouselP near 1 + idle) and the DIVE_START fallback.
    // Also exposed as window.__triggerAutoDive so the VIEW THE COLLECTION button can call it.
    function triggerAutoDive(durationMs) {
      if (window.__autoScrollAfterDive) return;
      window.__autoScrollAfterDive = true;
      const firstCell = document.getElementById('cell-01');
      if (!firstCell) return;
      const headerOffset = 80;
      // Compute absolute target Y via offsetParent walk (more reliable than getBoundingClientRect
      // when transforms are applied to the section, which can offset the rect).
      let absTop = 0;
      let el = firstCell;
      while (el) { absTop += el.offsetTop; el = el.offsetParent; }
      const targetY = absTop - headerOffset;
      // easeOutQuart — starts at full velocity, decelerates smoothly. Cards fall and settle.
      const easeOutQuart = (t) => 1 - Math.pow(1 - t, 4);
      if (lenis) {
        lenis.scrollTo(targetY, {
          duration: durationMs / 1000,
          easing: easeOutQuart,
          lock: true,
          force: true,
        });
        return;
      }
      // Native fallback: animate manually with input block + position pin
      const startY = window.scrollY;
      const distance = targetY - startY;
      if (Math.abs(distance) < 5) return;  // already there
      const startTime = performance.now();
      const blockInput = (e) => { e.preventDefault(); e.stopPropagation(); };
      document.addEventListener('touchmove', blockInput, { passive: false, capture: true });
      document.addEventListener('wheel', blockInput, { passive: false, capture: true });
      let lastForcedY = startY;
      function animateAutoDive(now) {
        const t = Math.min(1, (now - startTime) / durationMs);
        const eased = easeOutQuart(t);
        const expectedY = startY + distance * eased;
        // Position PIN: if browser/momentum drifted scrollY away from expected,
        // snap it back. Without this, native momentum from before the animation
        // can override our scrollTo and the screen falls behind the cards.
        if (Math.abs(window.scrollY - lastForcedY) > 1 || window.scrollY !== expectedY) {
          window.scrollTo(0, expectedY);
        }
        lastForcedY = expectedY;
        if (t < 1) {
          requestAnimationFrame(animateAutoDive);
        } else {
          document.removeEventListener('touchmove', blockInput, { capture: true });
          document.removeEventListener('wheel', blockInput, { capture: true });
        }
      }
      requestAnimationFrame(animateAutoDive);
    }
    // Expose globally so the VIEW THE COLLECTION button (outside this scope) can call it.
    if (!window.__triggerAutoDive) {
      window.__triggerAutoDive = triggerAutoDive;
    }

    // Compute orb-click lock once — used by dive trigger AND carousel reset logic below.
    // Was previously declared too late, causing a ReferenceError on the line below.
    const orbClickLocked = window.__orbClickInProgress || (window.__orbClickLockUntil && performance.now() < window.__orbClickLockUntil);

    // Auto-dive: when DIVE_START reached, smoothly scroll into Healer cell.
    // DESKTOP only — mobile uses explicit button/orb tap, no auto-dive.
    const isMobileForDive = window.matchMedia('(max-width: 768px)').matches;
    if (!isMobileForDive && progress >= DIVE_START && !window.__autoScrollAfterDive && !orbClickLocked) {
      triggerAutoDive(2600);
    }

    // Cylinder radius — orbs orbit around vertical axis at this distance.
    // Desktop: bigger radius (40% width, up to 750px) so carousel takes most of screen.
    // Mobile/tablet: tighter (30% width, up to 500px) — keeps the original feel that worked on small screens.
    const isDesktop = window.innerWidth >= 1024;
    const isMobileLayout = window.innerWidth < 768;
    const cylRadius = isDesktop
      ? Math.min(window.innerWidth * 0.40, 750)
      : isMobileLayout
        ? Math.min(window.innerHeight * 0.50, 500)  // vertical cylinder — fills more of viewport so cards spread fully top-to-bottom
        : Math.min(window.innerWidth * 0.30, 500);

    // Cylinder tilt — desktop uses X-axis tilt (cylinder leans back, back cards rise).
    // Mobile uses Y-axis tilt (cylinder leans sideways, back cards shift left).
    // Both create a perspective effect where back cards remain visible.
    const tiltRad = -18 * Math.PI / 180;
    const tiltCos = Math.cos(tiltRad);
    const tiltSin = Math.sin(tiltRad);
    // Mobile-only: Y-axis tilt amount (15° lean — slight, so depth is visible without cards falling off-axis)
    const mobileTiltRad = -15 * Math.PI / 180;
    const mobileTiltSin = Math.sin(mobileTiltRad);
    const mobileTiltCos = Math.cos(mobileTiltRad);

    // Carousel rotation amount (radians). Counterclockwise so cards come from RIGHT and exit LEFT.
    // Smooth-interpolate carouselP toward the scroll-driven target value for fluid rotation.
    // Without this, native scroll updates fire at variable rates (especially on mobile), causing
    // visible stepping in the cylinder rotation. Lerp dampens scroll jitter into smooth motion.
    let carouselRotRad = 0;
    let carouselP = 0;
    let targetCarouselP = 0;
    if (boomTriggered && progress >= TRANSITION_END) {
      targetCarouselP = Math.min(1, (progress - TRANSITION_END) / (CAROUSEL_END - TRANSITION_END));
    }
    // Persist smoothed value across frames
    if (typeof window.__smoothCarouselP !== 'number') window.__smoothCarouselP = 0;
    // Lerp toward target — 0.18 = ~3 frames to catch up, smooth but responsive
    window.__smoothCarouselP += (targetCarouselP - window.__smoothCarouselP) * 0.18;
    // Snap to target if very close (avoid asymptotic creep)
    if (Math.abs(targetCarouselP - window.__smoothCarouselP) < 0.001) {
      window.__smoothCarouselP = targetCarouselP;
    }
    carouselP = window.__smoothCarouselP;
    carouselRotRad = -carouselP * Math.PI * 2;  // negative = CCW from above

    // Re-arm the auto-dive when user returns to mid-carousel range. This way, scrolling
    // back up from cells into the cylinder re-triggers the auto-dive when they reach
    // Healer at front again — same mechanics every pass, not just the first one.
    // EXCEPT: when an orb-click auto-scroll is in progress (user navigating to a
    // specific cell), don't reset — the click handler set the flag intentionally.
    if (carouselP < 0.85 && window.__autoScrollAfterDive && !orbClickLocked) {
      window.__autoScrollAfterDive = false;
    }

    // === RETURN-PASS RESET: re-arm the auto quarter turn ===
    // When user scrolls all the way back UP into galaxy zone (progress < 0.30) after
    // having been past carousel before (window.__hasSeenCarousel is true), reset the
    // morph time so the cylinder re-plays its quarter turn animation when they scroll
    // forward again. Same cinematic intro every pass — Healer in front, full dial visible.
    // Only applies to mobile (only mobile has the auto morph + quarter turn).
    if (window.matchMedia('(max-width: 768px)').matches) {
      // Mark that user has seen carousel so we know to reset on return
      if (carouselP > 0.5) window.__hasSeenCarousel = true;
      // When they scroll back to galaxy zone, reset
      if (window.__hasSeenCarousel && progress < 0.30 && window.__mobileMorphStartTime) {
        window.__mobileMorphStartTime = null;
        window.__smoothCarouselP = 0;
        // Show rail in HOLD state — auto re-intro is about to play
        if (cRail) {
          cRail.classList.add('is-holding');
          cRail.classList.remove('is-swipe', 'is-engaged');
        }
        // Hide gate during reset
        if (cGate) {
          cGate.classList.remove('is-open');
          cGate.classList.remove('is-engaged');
        }
      }
      // When they scroll forward past 0.30 again, retrigger morph (as if BOOM just finished).
      // Use a separate flag so this only fires ONCE per re-entry, not every frame.
      if (window.__hasSeenCarousel && !window.__mobileMorphStartTime && progress >= 0.30 && progress < 0.36) {
        window.__mobileMorphStartTime = performance.now();
        // Block scroll briefly during the re-quarter-turn (1500ms morph + 1200ms quarter = 2700ms)
        // Shorter than the first pass since galaxy hover is skipped.
        const blockScroll = (e) => e.preventDefault();
        document.addEventListener('touchmove', blockScroll, { passive: false });
        document.addEventListener('wheel', blockScroll, { passive: false });
        setTimeout(() => {
          document.removeEventListener('touchmove', blockScroll);
          document.removeEventListener('wheel', blockScroll);
          // Transition rail: hold → swipe
          if (cRail) {
            cRail.classList.remove('is-holding');
            cRail.classList.add('is-swipe');
          }
          if (cGate) cGate.classList.add('is-open');
        }, 2700);
      }
    }

    // === Auto-dive trigger: cylinder near-full-revolution + user idle ===
    // Fire BEFORE progress reaches DIVE_START so user doesn't get stuck in a dead zone
    // between "cylinder rotation complete" and "first cell visible". When carouselP is
    // close to 1 (Healer back at front) AND user has stopped scrolling briefly, auto-scroll
    // smoothly into the first cell so the cards visibly fall and the screen follows.
    if (!isMobileForDive && carouselP >= 0.92 && !window.__autoScrollAfterDive && !orbClickLocked && window.__boomTriggered) {
      const idleTime = performance.now() - (window.__lastUserScrollTime || 0);
      if (idleTime > 250) {
        triggerAutoDive(2400);
      }
    }

    // === Mobile auto-rotation hint ===
    // After the orbs morph into cylinder formation, automatically rotate the cylinder
    // a quarter turn so the user SEES it move and lands on Healer (the first card).
    // From there, all rotation is user-driven via scroll.
    //
    // Phases:
    //   0 - 2800ms after __mobileMorphStartTime: morph (orbs assemble at -90° rotation)
    //   2800 - 4300ms: QUARTER TURN — rotate from -90° back to 0° (healer at front)
    //   4300ms+: bonus stays at 0; user scroll fully drives any further rotation
    let mobileBonusRotRad = 0;
    const MORPH_DURATION = 2800;
    const QUARTER_TURN_DURATION = 1500;
    const INITIAL_BONUS_RAD = -Math.PI / 2;     // -90° = 3 cards back from healer
    if (isMobileLayout && window.__mobileMorphStartTime) {
      const morphElapsed = performance.now() - window.__mobileMorphStartTime;
      if (morphElapsed < MORPH_DURATION) {
        // Phase 1: morph in progress — hold cylinder at initial rotated position
        mobileBonusRotRad = INITIAL_BONUS_RAD;
      } else if (morphElapsed < MORPH_DURATION + QUARTER_TURN_DURATION) {
        // Phase 2: QUARTER TURN — rotate from -90° back to 0°
        const autoElapsed = morphElapsed - MORPH_DURATION;
        const autoT = Math.min(1, autoElapsed / QUARTER_TURN_DURATION);
        // easeInOutSine — soft start, soft end (matches morph easing)
        const eased = -(Math.cos(Math.PI * autoT) - 1) / 2;
        mobileBonusRotRad = INITIAL_BONUS_RAD * (1 - eased);
      } else {
        // Phase 3: bonus stays at 0 (Healer at front).
        // User scroll-rotation now fully drives any further movement.
        mobileBonusRotRad = 0;
      }
    }

    // === Orbs ===
    orbs.forEach((orb, i) => {
      const fp = finalPositions[i];
      const dp = driftParams[i];
      let x, y, z, scale, opacity, label, rot = 0;

      // Cylinder calculations (used in transition + carousel + dive)
      const baseAngleRad = (i * 30) * Math.PI / 180;
      // Mobile rotates in the opposite direction (was reversed) so cards come from above.
      // Mobile also adds the bonus auto-rotation that runs after morph completes.
      const effectiveCarouselRot = (isMobileLayout ? -carouselRotRad : carouselRotRad) + mobileBonusRotRad;
      const currentAngleRad = baseAngleRad + effectiveCarouselRot;
      let carX, carY, carZ, currentAngleDeg, zNorm;
      if (isMobileLayout) {
        // VERTICAL CYLINDER (mobile): cards orbit around the horizontal X-axis.
        // - sin(angle) controls vertical position (Y) — top = -radius, bottom = +radius
        // - cos(angle) controls depth (Z)
        // Y-axis tilt: back cards (negative Z) shift to the LEFT, front cards stay centered.
        // X-OFFSET: push the whole cylinder right to compensate for the tilt-induced
        // left-lean (mean of carX across 12 cards is negative, so visual mass is left of center).
        const rawY = Math.sin(currentAngleRad) * cylRadius;
        const rawZ = -cylRadius + Math.cos(currentAngleRad) * cylRadius;
        const cylinderXOffset = cylRadius * mobileTiltSin * -0.5;  // half-compensation: balance back-card lean without overshooting right
        carX = -rawZ * mobileTiltSin + cylinderXOffset;
        carY = rawY;
        carZ = rawZ * mobileTiltCos;
        // Orb face rotation: card rotates on X-axis as it travels around the cylinder
        currentAngleDeg = -((i * 30) + (-carouselP * 360));
        zNorm = (Math.cos(currentAngleRad) + 1) / 2;
      } else {
        // HORIZONTAL CYLINDER (desktop): cards orbit around vertical Y-axis (original behavior).
        const rawX = Math.sin(currentAngleRad) * cylRadius;
        const rawZ = -cylRadius + Math.cos(currentAngleRad) * cylRadius;
        carX = rawX;
        carY = -rawZ * tiltSin;
        carZ = rawZ * tiltCos;
        currentAngleDeg = (i * 30) + (-carouselP * 360);
        zNorm = (Math.cos(currentAngleRad) + 1) / 2;
      }
      // Front-prominent scale: front cards 1.0, back cards 0.55
      const carScale = 0.55 + 0.45 * zNorm;

      // Galaxy hover position (full drift — bob/sway/orbit/scale-breathing/rotation)
      const galaxyHover = () => {
        const bob = Math.sin(driftT * dp.bobSpeed + dp.bobOffset) * dp.bobAmp;
        const sway = Math.cos(driftT * dp.swaySpeed + dp.swayOffset) * dp.swayAmp;
        const orbitT = driftT * dp.orbitSpeed * dp.orbitDir + dp.orbitOffset;
        const orbitX = Math.cos(orbitT) * dp.orbitRadius;
        const orbitY = Math.sin(orbitT) * dp.orbitRadius * 0.7;
        return {
          x: fp.x + sway + orbitX,
          y: fp.y + bob + orbitY,
          z: fp.z,
          scale: 0.90 + Math.sin(driftT * dp.scaleSpeed + dp.scaleOffset) * 0.04,
          rot: Math.sin(driftT * dp.rotSpeed + dp.rotOffset) * 1.5,
        };
      };

      // === MOBILE BUILD STATE override (scroll-driven shrink) ===
      // State machine:
      //   'idle'      → all cards hidden (manifesto reading)
      //   'building'  → all 12 visible on a HUGE cylinder; native scroll shrinks it
      //   'complete'  → cylinder at normal radius; native scroll free-spins it
      // The build phase consumes scroll progress 0.20 → 0.65 (45% of section).
      // Past 0.65, cylinder is compact and continues to rotate via scroll.
      const mobileBuildActive = isMobileLayout && window.__mobileBuildState && progress < DIVE_START;

      if (mobileBuildActive) {
        const state = window.__mobileBuildState;
        const BUILD_START = 0.18;
        const BUILD_END = 0.55;
        const SPIN_END = 0.97;
        if (state === 'idle' || (state === 'building' && progress < BUILD_START)) {
          // Manifesto still reading OR not yet scrolled into build phase — cards hidden
          x = 0; y = -window.innerHeight; z = 0; scale = 1; opacity = 0; label = 0;
        } else {
          // Build progress: 0 = huge cylinder, 1 = compact cylinder
          let buildP;
          if (state === 'complete') {
            buildP = 1;  // returning users start fully compact
          } else {
            buildP = Math.max(0, Math.min(1, (progress - BUILD_START) / (BUILD_END - BUILD_START)));
            // Auto-promote state to 'complete' when shrink finishes
            if (buildP >= 0.999) {
              window.__mobileBuildState = 'complete';
              const btn = document.getElementById('luxeViewCollection');
              if (btn) btn.classList.add('is-visible');
              if (cRail) cRail.classList.add('is-complete', 'is-swipe');
              // Also reveal back-up button
              const backBtn = document.getElementById('luxeBackToTop');
              if (backBtn) backBtn.classList.add('is-visible');
            }
          }
          // Smooth ease for the shrink — easeInOutCubic gives a gentle sweep
          const buildEased = buildP < 0.5
            ? 4 * buildP * buildP * buildP
            : 1 - Math.pow(-2 * buildP + 2, 3) / 2;

          // === Manifesto fade-out as cylinder builds ===
          if (cManifesto) {
            const manifestoFade = Math.max(0, 1 - buildP / 0.3);
            cManifesto.style.opacity = manifestoFade.toFixed(3);
          }

          // Radius shrinks from 2.6x to 0.88x — smaller compact size leaves room for bottom button
          const HUGE_RADIUS_MULTIPLIER = 2.6;
          const COMPACT_RADIUS_MULTIPLIER = 0.88;
          const dynamicRadius = cylRadius * (HUGE_RADIUS_MULTIPLIER - (HUGE_RADIUS_MULTIPLIER - COMPACT_RADIUS_MULTIPLIER) * buildEased);

          // Cylinder rotation:
          //   Building phase: -π/2 → 0 as cylinder shrinks (Healer settles to front)
          //   Compact phase 0.55 → 0.97: scroll drives 0 → 4π (2 full revolutions = generous spin room)
          //   Past 0.97: rotation freezes at 4π, cylinder stays put. Only button/orb tap exits.
          let rotOffset;
          if (state === 'complete' && progress >= BUILD_END) {
            const spinP = Math.max(0, Math.min(1, (progress - BUILD_END) / (SPIN_END - BUILD_END)));
            rotOffset = -spinP * Math.PI * 4;
          } else if (state === 'complete') {
            rotOffset = 0;
          } else {
            rotOffset = -Math.PI / 2 + (Math.PI / 2) * buildEased;
          }

          const angleWithRot = baseAngleRad + rotOffset;
          const baseRawY = Math.sin(angleWithRot) * dynamicRadius;
          const baseRawZ = -dynamicRadius + Math.cos(angleWithRot) * dynamicRadius;
          const targetX = -baseRawZ * mobileTiltSin + (dynamicRadius * mobileTiltSin * -0.5);
          const targetY = baseRawY;
          const targetZ = baseRawZ * mobileTiltCos;
          const baseZNorm = (Math.cos(angleWithRot) + 1) / 2;
          const targetScale = 0.55 + 0.45 * baseZNorm;

          x = targetX;
          y = targetY + Math.sin(driftT * dp.bobSpeed + dp.bobOffset) * dp.bobAmp * 0.2;
          z = targetZ;
          scale = targetScale * COMPACT_RADIUS_MULTIPLIER;
          if (buildEased < 0.85) {
            opacity = 0.55 + 0.45 * baseZNorm;
          } else {
            opacity = 0.32 + 0.68 * baseZNorm;
          }
          label = baseZNorm;
          rot = Math.sin(driftT * dp.rotSpeed + dp.rotOffset) * 1.0 * baseZNorm;
        }
      } else {
      // === Mobile auto-phase override (legacy — only used now if old flow flags set) ===
      // When BOOM has fired AND we're within the morph+quarter-turn window,
      // FORCE time-based positioning regardless of where user has scrolled.
      const inMobileAutoPhase = isMobileLayout && boomTriggered && window.__mobileMorphStartTime &&
        (performance.now() - window.__mobileMorphStartTime < MORPH_DURATION + QUARTER_TURN_DURATION);

      // === SKIP-INTRO override (desktop only — mobile uses build state above) ===
      const skipIntroActive = window.__skipIntro && !isMobileLayout && !inMobileAutoPhase && progress < DIVE_START;

      if (skipIntroActive) {
        // Carousel-phase rendering using the carX/carY/carZ already computed above.
        // carouselP follows actual scroll progress, so cylinder rotates as user scrolls.
        x = carX;
        y = carY + Math.sin(driftT * dp.bobSpeed + dp.bobOffset) * dp.bobAmp * 0.3;
        z = carZ;
        scale = carScale;
        opacity = 0.32 + 0.68 * zNorm;
        label = zNorm;
        rot = Math.sin(driftT * dp.rotSpeed + dp.rotOffset) * 1.0 * zNorm;
      } else if (!boomTriggered) {
        // Pre-BOOM: hidden at center
        x = 0; y = 0; z = -100; scale = 0.3; opacity = 0; label = 0;
      } else if (autoplayInProgress) {
        // BOOM auto-play: fly from center to GALAXY position (restored from v30/v31 behavior)
        const distance = Math.hypot(fp.x, fp.y);
        const distRatio = Math.min(1, distance / 380);
        const orbDuration = 0.65 + 0.35 * distRatio;
        const orbProgress = Math.min(1, autoplayProgress / orbDuration);
        const eased = easeOutCubic(orbProgress);
        x = fp.x * eased;
        y = fp.y * eased;
        z = -100 + (fp.z + 100) * eased;
        scale = 0.3 + 0.6 * eased;
        opacity = Math.min(1, eased * 2);
        label = eased * 0.7;
      } else if (inMobileAutoPhase) {
        // === MOBILE AUTO PHASE — time-based morph + quarter turn ===
        // Galaxy → cylinder over MORPH_DURATION, then cylinder rotates -90° → 0° via mobileBonusRotRad.
        // This block runs regardless of user's scroll progress, ensuring smooth cinematic intro.
        const morphElapsed = performance.now() - window.__mobileMorphStartTime;
        const morphT = Math.min(1, morphElapsed / MORPH_DURATION);
        const eased = -(Math.cos(Math.PI * morphT) - 1) / 2;  // easeInOutSine
        const h = galaxyHover();
        // Target uses bonus-shifted angle (so during quarter turn, cylinder is at the rotated position)
        const angleWithBonus = baseAngleRad + mobileBonusRotRad;
        const baseRawY = Math.sin(angleWithBonus) * cylRadius;
        const baseRawZ = -cylRadius + Math.cos(angleWithBonus) * cylRadius;
        const targetX = -baseRawZ * mobileTiltSin + (cylRadius * mobileTiltSin * -0.5);
        const targetY = baseRawY;
        const targetZ = baseRawZ * mobileTiltCos;
        const baseZNorm = (Math.cos(angleWithBonus) + 1) / 2;
        const targetScale = 0.55 + 0.45 * baseZNorm;
        x = h.x * (1 - eased) + targetX * eased;
        y = h.y * (1 - eased) + targetY * eased;
        z = h.z * (1 - eased) + targetZ * eased;
        scale = h.scale * (1 - eased) + targetScale * eased;
        rot = h.rot * (1 - eased);
        opacity = 1;
        label = 1 - eased * (1 - baseZNorm);
      } else if (progress < GALAXY_HOVER_END) {
        // Galaxy hover — orbs drift with bob/sway/orbital motion (full chaos drift)
        // ON MOBILE: if __mobileMorphStartTime is set, use TIME-based interpolation
        // from galaxy → cylinder regardless of scroll progress. After morph completes
        // (1.5s), orbs sit in cylinder formation. User's scroll then drives rotation.
        if (isMobileLayout && window.__mobileMorphStartTime) {
          const morphElapsed = performance.now() - window.__mobileMorphStartTime;
          const morphT = Math.min(1, morphElapsed / 2800);
          const eased = -(Math.cos(Math.PI * morphT) - 1) / 2; // easeInOutSine — gentler than cubic
          const h = galaxyHover();
          // Target: cylinder base position with Y-tilt for depth perspective
          const angleWithBonus = baseAngleRad + mobileBonusRotRad;
          const baseRawY = Math.sin(angleWithBonus) * cylRadius;
          const baseRawZ = -cylRadius + Math.cos(angleWithBonus) * cylRadius;
          const targetX = -baseRawZ * mobileTiltSin + (cylRadius * mobileTiltSin * -0.5);  // back cards shift left, X-offset to recenter
          const targetY = baseRawY;
          const targetZ = baseRawZ * mobileTiltCos;
          const baseZNorm = (Math.cos(angleWithBonus) + 1) / 2;
          const targetScale = 0.55 + 0.45 * baseZNorm;
          x = h.x * (1 - eased) + targetX * eased;
          y = h.y * (1 - eased) + targetY * eased;
          z = h.z * (1 - eased) + targetZ * eased;
          scale = h.scale * (1 - eased) + targetScale * eased;
          rot = h.rot * (1 - eased);
          opacity = 1;
          label = 1 - eased * (1 - baseZNorm);
        } else {
          const h = galaxyHover();
          x = h.x; y = h.y; z = h.z; scale = h.scale; rot = h.rot;
          opacity = 1; label = 1;
        }
      } else if (progress < TRANSITION_END) {
        // TRANSITION — galaxy → cylinder. Quick interpolation, easeInOut for smooth feel.
        // ON MOBILE: if time-based morph is in progress or complete, use that
        // instead of scroll-based to avoid undoing the morph.
        if (isMobileLayout && window.__mobileMorphStartTime) {
          const morphElapsed = performance.now() - window.__mobileMorphStartTime;
          const morphT = Math.min(1, morphElapsed / 2800);
          const eased = -(Math.cos(Math.PI * morphT) - 1) / 2; // easeInOutSine — gentler than cubic
          const h = galaxyHover();
          const angleWithBonus = baseAngleRad + mobileBonusRotRad;
          const baseRawY = Math.sin(angleWithBonus) * cylRadius;
          const baseRawZ = -cylRadius + Math.cos(angleWithBonus) * cylRadius;
          const targetX = -baseRawZ * mobileTiltSin + (cylRadius * mobileTiltSin * -0.5);  // back cards shift left, X-offset to recenter
          const targetY = baseRawY;
          const targetZ = baseRawZ * mobileTiltCos;
          const baseZNorm = (Math.cos(angleWithBonus) + 1) / 2;
          const targetScale = 0.55 + 0.45 * baseZNorm;
          x = h.x * (1 - eased) + targetX * eased;
          y = h.y * (1 - eased) + targetY * eased;
          z = h.z * (1 - eased) + targetZ * eased;
          scale = h.scale * (1 - eased) + targetScale * eased;
          rot = h.rot * (1 - eased);
          opacity = 1;
          label = 1 - eased * (1 - baseZNorm);
        } else {
          const t = (progress - GALAXY_HOVER_END) / (TRANSITION_END - GALAXY_HOVER_END);
          const eased = easeInOutCubic(t);
          // Source: galaxy with continued drift (so it doesn't snap)
          const h = galaxyHover();
          // Target: tilted cylinder position at base angle (no rotation yet)
          const rawTargetX = Math.sin(baseAngleRad) * cylRadius;
          const rawTargetZ = -cylRadius + Math.cos(baseAngleRad) * cylRadius;
          const targetX = rawTargetX;
          const targetY = -rawTargetZ * tiltSin;
          const targetZ = rawTargetZ * tiltCos;
          const baseZNorm = (Math.cos(baseAngleRad) + 1) / 2;
          const targetScale = 0.55 + 0.45 * baseZNorm;

          x = h.x * (1 - eased) + targetX * eased;
          y = h.y * (1 - eased) + targetY * eased;  // y lerps to tilted cylinder y
          z = h.z * (1 - eased) + targetZ * eased;
          scale = h.scale * (1 - eased) + targetScale * eased;
          // rotateY ramps up from 0 to baseAngle — cards rotate to face outward as they reach cylinder
          opacity = 1;
          label = 1 - eased * (1 - baseZNorm);  // labels fade slightly for back-positioned cards
        }
      } else if (progress < CAROUSEL_END) {
        // 3D CAROUSEL — billboard cards (always face camera). Depth comes from scale + tilt + opacity.
        // All cards stay visible at all times — back cards dim to ~32% but never disappear.
        x = carX;
        y = carY + Math.sin(driftT * dp.bobSpeed + dp.bobOffset) * dp.bobAmp * 0.3;
        z = carZ;
        scale = carScale;
        opacity = 0.32 + 0.68 * zNorm;  // back: 0.32, front: 1.0
        label = zNorm;
        rot = Math.sin(driftT * dp.rotSpeed + dp.rotOffset) * 1.0 * zNorm;
      } else {
        // DIVE — fade away from current cylinder position
        const b5 = (progress - DIVE_START) / (1 - DIVE_START);
        const eased = easeInCubic(b5);
        x = carX * (1 - eased);
        y = carY * (1 - eased) + wh * eased;
        z = carZ * (1 - eased);
        scale = carScale * (1 - 0.5 * eased);
        const startOpacity = 0.32 + 0.68 * zNorm;
        opacity = startOpacity * (1 - eased);
        label = (1 - eased) * zNorm;
      }
      }  // close mobileBuildActive else wrapper

      orb.style.setProperty('--ox', x.toFixed(1) + 'px');
      orb.style.setProperty('--oy', y.toFixed(1) + 'px');
      orb.style.setProperty('--oz', z.toFixed(0) + 'px');
      orb.style.setProperty('--os', scale.toFixed(3));
      orb.style.setProperty('--orot', rot.toFixed(2) + 'deg');
      orb.style.setProperty('--oo', opacity.toFixed(2));
      orb.style.setProperty('--ol', label.toFixed(2));
      // z-index: front cards on top
      orb.style.setProperty('--oi', Math.round(1000 + z));
    });
  }

  // === SIDENAV — show during cells, highlight current ===
  const sidenav = document.getElementById('sidenav');
  const sidenavLinks = sidenav ? Array.from(sidenav.querySelectorAll('.sidenav__link')) : [];
  const allCells = Array.from(document.querySelectorAll('.cell'));
  const interlude = document.querySelector('.interlude');

  function updateSidenav() {
    if (!sidenav) return;
    const wh = window.innerHeight;

    // Show sidenav when first cell enters view, hide when interlude/teaser is dominant
    let showNav = false;
    let currentIdx = -1;
    let bestDistance = Infinity;
    allCells.forEach((cell, i) => {
      const r = cell.getBoundingClientRect();
      // If any cell is at all in viewport
      if (r.top < wh * 0.8 && r.bottom > wh * 0.2) {
        showNav = true;
      }
      // Active = closest to viewport center
      const cellCenter = r.top + r.height/2;
      const distance = Math.abs(cellCenter - wh/2);
      if (distance < bestDistance) {
        bestDistance = distance;
        currentIdx = i;
      }
    });

    if (showNav) sidenav.classList.add('is-active');
    else sidenav.classList.remove('is-active');

    sidenavLinks.forEach((link, i) => {
      link.classList.toggle('is-current', i === currentIdx && showNav);
    });
  }

  // (Cylinder pin logic removed — replaced with native scroll-driven free spin via
  // extended scroll range. See orb math in updateConstellation for details.)

  // === Mobile: VIEW THE COLLECTION button wire-up + returning-user state ===
  // No swipe handlers, no scroll hijack — everything is native scroll-driven now.
  // The orb math reads scroll progress to drive cylinder shrink + rotation.
  if (window.matchMedia('(max-width: 768px)').matches) {
    // === VIEW THE COLLECTION button — wires to auto-dive into cell-01 ===
    const viewBtn = document.getElementById('luxeViewCollection');
    if (viewBtn) {
      viewBtn.addEventListener('click', () => {
        // Trigger the dive — same as scrolling past DIVE_START or hitting end of cylinder
        if (typeof window.__triggerAutoDive === 'function') {
          window.__triggerAutoDive(2400);
        } else {
          // Fallback: smooth scroll to first cell
          const firstCell = document.getElementById('cell-01');
          if (firstCell) {
            firstCell.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
        // Hide button after click — user committed to descending
        viewBtn.classList.remove('is-visible');
      });
    }

    // === Back-to-top button — smooth scroll to top of page (hero video) ===
    const backBtn = document.getElementById('luxeBackToTop');
    if (backBtn) {
      backBtn.addEventListener('click', () => {
        // Smooth scroll to absolute top
        if (window.lenis) {
          window.lenis.scrollTo(0, { duration: 1.6, lock: false, force: true });
        } else {
          const startY = window.scrollY;
          const duration = 1400;
          const startTime = performance.now();
          function animateScrollUp(now) {
            const t = Math.min(1, (now - startTime) / duration);
            const eased = t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
            window.scrollTo(0, startY * (1 - eased));
            if (t < 1) requestAnimationFrame(animateScrollUp);
          }
          requestAnimationFrame(animateScrollUp);
        }
      });
    }
    // Show buttons immediately for returning users (cylinder pre-compact)
    if (window.__mobileBuildState === 'complete') {
      if (viewBtn) viewBtn.classList.add('is-visible');
      if (backBtn) backBtn.classList.add('is-visible');
      if (cRail) cRail.classList.add('is-complete', 'is-swipe');
    }
  }

  // Need rAF to keep drift moving even without scroll
  let constellationRAF = null;
  function constellationLoop() {
    updateConstellation();
    constellationRAF = requestAnimationFrame(constellationLoop);
  }
  // Only run loop when constellation is in view
  if (constellation) {
    const cObs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          if (!constellationRAF) constellationLoop();
        } else {
          if (constellationRAF) {
            cancelAnimationFrame(constellationRAF);
            constellationRAF = null;
          }
        }
      });
    }, { threshold: 0 });
    cObs.observe(constellation);
    // Cleanup: cancel rAF and disconnect observer
    __cleanupCallbacks.push(() => {
      if (constellationRAF) cancelAnimationFrame(constellationRAF);
      constellationRAF = null;
      cObs.disconnect();
    });
  }

  // === Lenis smooth scroll ===
  let lenis = null;
  if (window.Lenis && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    try {
      lenis = new Lenis({
        duration: 1.15,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        smoothWheel: true,
      });
      function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
      requestAnimationFrame(raf);
    } catch(e) { lenis = null; }
  }

  // === Reverse-direction snap: scroll up from cell-01 → snap to carousel state ===
  // The forward auto-scroll (in updateConstellation) handles the "going down" side of the
  // dead zone — but without this listener, scrolling UP from cell-01 lands the user in the
  // 100vh constellation slide-out phase where cards have already flown down. That's the
  // "boring green bg with no cards" state. They'd need ~13 wheel ticks of upward scroll
  // to reach carousel state.
  // With this listener: ONE upward wheel tick from cell-01 snaps the user back to progress
  // 0.77 (carousel last frame, cards visible). The __autoScrollAfterDive flag resets so the
  // forward auto-scroll re-fires next time they scroll down. Reversible loop.
  if (lenis) {
    let __reverseTrackerScroll = -1;
    lenis.on('scroll', ({ scroll }) => {
      if (__reverseTrackerScroll < 0) { __reverseTrackerScroll = scroll; return; }
      const goingUp = scroll < __reverseTrackerScroll;
      __reverseTrackerScroll = scroll;

      if (!goingUp || !window.__autoScrollAfterDive || window.__reverseScrolling) return;

      const wh = window.innerHeight;
      const cell01 = document.getElementById('cell-01');
      if (!cell01 || !constellation) return;

      const cell01Top = cell01.offsetTop;
      const constellationTop = constellation.offsetTop;
      const sectionScrollRange = constellation.offsetHeight - wh;
      const carouselTargetScroll = constellationTop + sectionScrollRange * 0.77;
      const deadZoneStart = constellationTop + sectionScrollRange * 0.78;

      // In dead zone (between carousel-end and cell-01 top) AND going up → snap to carousel
      if (scroll > deadZoneStart && scroll < cell01Top + 10) {
        window.__reverseScrolling = true;
        window.__autoScrollAfterDive = false;  // allow forward auto-scroll to re-trigger
        lenis.scrollTo(carouselTargetScroll, {
          duration: 0.4,
          easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
          onComplete: () => { window.__reverseScrolling = false; },
        });
      }
    });
  }

  // === SCROLL GATES — auto-release after idle pause ===
  //   Gate 1 (BOOM): clamp at progress 0.14 until 400ms of idle has passed since gate opened.
  //   Gate 2 (CAROUSEL): clamp at progress 0.30, same auto-release after 400ms.
  // Earlier versions required a "fresh scroll input" after idle, but that proved fragile —
  // wheel-event timing relative to Lenis's own scroll handler caused the gate to occasionally
  // stay locked even after the user scrolled. Now: just wait 400ms after gate opens, then
  // release. The barrier-snap + pause still provides the deliberate moment.
  const MIN_CHARGE_TIME_MS = 1000;
  let cachedBoomBarrier = null;
  let cachedCarouselBarrier = null;

  function computeBoomBarrier() {
    if (!constellation) return null;
    const wh = window.innerHeight;
    const sectionScrollRange = constellation.offsetHeight - wh;
    if (sectionScrollRange <= 0) return null;
    let absTop = 0;
    let el = constellation;
    while (el) { absTop += el.offsetTop; el = el.offsetParent; }
    return absTop + 0.14 * sectionScrollRange;
  }
  function computeCarouselBarrier() {
    if (!constellation) return null;
    const wh = window.innerHeight;
    const sectionScrollRange = constellation.offsetHeight - wh;
    if (sectionScrollRange <= 0) return null;
    let absTop = 0;
    let el = constellation;
    while (el) { absTop += el.offsetTop; el = el.offsetParent; }
    return absTop + 0.30 * sectionScrollRange;  // end of galaxy hover phase
  }
  function refreshBarriers() {
    cachedBoomBarrier = computeBoomBarrier();
    cachedCarouselBarrier = computeCarouselBarrier();
    // Expose for in-browser diagnosis. Inspect with:
    //   window.__luxeDebug()
    window.__luxeDebug = function () {
      var c = document.getElementById('constellation');
      return {
        boomBarrier: cachedBoomBarrier,
        carouselBarrier: cachedCarouselBarrier,
        scrollY: window.scrollY,
        constellationOffsetHeight: c ? c.offsetHeight : null,
        constellationOffsetTop: c ? c.offsetTop : null,
        constellationRectTop: c ? c.getBoundingClientRect().top : null,
        windowInnerHeight: window.innerHeight,
        skipIntro: window.__skipIntro,
        boomReady: window.__boomReady,
        boomTriggered: window.__boomTriggered,
        manifestoRevealed: window.__manifestoRevealed
      };
    };
  }
  // Try at script eval time (might be too early if layout not settled)
  refreshBarriers();
  // Try after first frame (DOM has painted)
  requestAnimationFrame(refreshBarriers);
  // Try after 100ms (most layout settled)
  setTimeout(refreshBarriers, 100);
  // Try after window 'load' event (all images/fonts loaded — most reliable)
  if (document.readyState !== 'complete') {
    _addListener(window, 'load', refreshBarriers);
  }
  _addListener(window, 'resize', refreshBarriers);

  // Gate state — track when each gate opened so we can auto-release after a pause
  let lastUserScrollTime = 0;
  let boomGateOpenedAt = null;
  let carouselGateOpenedAt = null;
  const GATE_PAUSE_MS = 400;  // idle pause before auto-releasing each gate

  const markUserScroll = () => {
    lastUserScrollTime = performance.now();
    window.__lastUserScrollTime = lastUserScrollTime;  // expose for auto-dive idle check
  };
  _addListener(window, 'wheel', markUserScroll, { passive: true });
  _addListener(window, 'touchmove', markUserScroll, { passive: true });
  _addListener(window, 'keydown', (e) => {
    if (['ArrowDown','ArrowUp','PageDown','PageUp',' ','Space','End','Home'].includes(e.key)) {
      markUserScroll();
    }
  });

  // Gate auto-release loop — opens-time-stamp, then releases after pause.
  // BOOM gate: pure time-based (400ms after open).
  // CAROUSEL gate: timer starts ONLY ONCE USER REACHES THE BARRIER (so they're held in
  //   galaxy hover formation for 1500ms before being allowed to enter the carousel rotation).
  //   If we started the timer at gate-open like the BOOM gate, fast scrollers could race
  //   past 0.30 before the gate ever clamped — skipping galaxy hover entirely.
  const CAROUSEL_GATE_PAUSE_MS = 1500;
  function checkGateIdle() {
    const now = performance.now();
    // BOOM gate
    if (window.__boomGateOpen && !window.__boomReady) {
      if (boomGateOpenedAt === null) boomGateOpenedAt = now;
      const sinceGateOpen = now - boomGateOpenedAt;
      if (sinceGateOpen >= GATE_PAUSE_MS) {
        window.__boomReady = true;
      }
    }
    // CAROUSEL gate — timer doesn't start until user reaches the barrier
    if (window.__carouselGateOpen && !window.__carouselReady && cachedCarouselBarrier !== null) {
      const scroll = window.scrollY;
      // Only start the timer once the user has actually scrolled to the barrier
      if (scroll >= cachedCarouselBarrier - 10) {
        if (carouselGateOpenedAt === null) carouselGateOpenedAt = now;
        const sinceAtBarrier = now - carouselGateOpenedAt;
        if (sinceAtBarrier >= CAROUSEL_GATE_PAUSE_MS) {
          window.__carouselReady = true;
        }
      }
    }
    requestAnimationFrame(checkGateIdle);
  }
  requestAnimationFrame(checkGateIdle);

  // Lenis clamp — checks barriers in priority order.
  let __isClamping = false;
  if (lenis) {
    lenis.on('scroll', ({ scroll }) => {
      if (__isClamping) return;
      // BOOM barrier — clamps at 0.14 until __boomReady (idle + fresh scroll).
      if (!window.__boomReady && cachedBoomBarrier !== null && scroll > cachedBoomBarrier) {
        __isClamping = true;
        lenis.scrollTo(cachedBoomBarrier, { immediate: true });
        setTimeout(() => { __isClamping = false; }, 50);
        return;
      }
      // CAROUSEL barrier — clamps at 0.30 only AFTER BOOM has fired and gate has opened.
      if (window.__carouselGateOpen && !window.__carouselReady && cachedCarouselBarrier !== null && scroll > cachedCarouselBarrier) {
        __isClamping = true;
        lenis.scrollTo(cachedCarouselBarrier, { immediate: true });
        setTimeout(() => { __isClamping = false; }, 50);
        return;
      }
    });
  }

  // === Native scroll barrier (works with or without Lenis) ===
  // On mobile (and any environment without Lenis), the previous Lenis-only clamp
  // didn't fire — letting users scroll past BOOM and carousel barriers, skipping
  // the entire orbit animation. This rAF loop enforces the same barriers natively.
  function nativeScrollClamp() {
    if (constellation) {
      const rect = constellation.getBoundingClientRect();
      const wh = window.innerHeight;
      // Only clamp when section is in or near viewport
      if (rect.top < wh && rect.bottom > 0) {
        const scroll = window.scrollY;
        // BOOM barrier — held until __boomReady (after manifesto + grace pause)
        if (!window.__boomReady && cachedBoomBarrier !== null && scroll > cachedBoomBarrier) {
          window.scrollTo(0, cachedBoomBarrier);
        }
        // CAROUSEL barrier — held in galaxy hover until __carouselReady (~1500ms after barrier reached)
        else if (window.__carouselGateOpen && !window.__carouselReady && cachedCarouselBarrier !== null && scroll > cachedCarouselBarrier) {
          window.scrollTo(0, cachedCarouselBarrier);
        }
      }
    }
    requestAnimationFrame(nativeScrollClamp);
  }
  requestAnimationFrame(nativeScrollClamp);

  // === Orb click → smooth guided scroll-tour to the target cell ===
  // Slower, cinematic duration so user sees each cell tilt past on the way
  if (orbs && orbs.length) {
    orbs.forEach(orb => {
      orb.addEventListener('click', (e) => {
        const href = orb.getAttribute('href');
        if (!href || !href.startsWith('#')) return;
        const target = document.querySelector(href);
        if (!target) return;
        e.preventDefault();
        // Prevent dive auto-fire from competing — we're navigating to a specific cell,
        // not auto-diving to Healer. The dive code checks this flag.
        window.__autoScrollAfterDive = true;
        // Track the orb-click auto-scroll explicitly so the carouselP < 0.85 reset
        // logic doesn't reset the dive flag mid-scroll, and so the auto-dive
        // trigger respects this in-progress navigation.
        window.__orbClickInProgress = true;
        // Also set a timestamp-based lock as belt-and-suspenders. Even if the flag
        // gets cleared prematurely (e.g. Lenis onComplete fires on animation interruption),
        // the timestamp protects for the full intended scroll duration. Buffer of 500ms past expected scroll completion.
        window.__orbClickLockUntil = performance.now() + 3000;
        // Compute scroll position so the target cell is centered vertically
        // in the viewport (with header offset accounted for). Otherwise the
        // cell's top sits flush against the viewport top and gets hidden by
        // the fixed header — leaving the user looking at the bottom of a card.
        const headerOffset = 80;
        const cellRect = target.getBoundingClientRect();
        const cellCenter = cellRect.top + window.scrollY + cellRect.height / 2;
        const viewportCenter = window.innerHeight / 2;
        const scrollTarget = cellCenter - viewportCenter + (headerOffset / 2);
        if (lenis) {
          // Lock prevents user touches from interrupting the cinematic scroll
          lenis.scrollTo(scrollTarget, {
            duration: 2.6,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            lock: true,
            force: true,
            onComplete: () => { window.__orbClickInProgress = false; },
          });
        } else {
          // Native fallback: animate scroll manually + lock user input so touch
          // momentum / wheel events can't fight the scroll animation.
          const startY = window.scrollY;
          const distance = scrollTarget - startY;
          const duration = 2400;
          const startTime = performance.now();
          const lockScroll = (ev) => ev.preventDefault();
          document.addEventListener('touchmove', lockScroll, { passive: false });
          document.addEventListener('wheel', lockScroll, { passive: false });
          function animateOrbScroll(now) {
            const t = Math.min(1, (now - startTime) / duration);
            const eased = t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
            window.scrollTo(0, startY + distance * eased);
            if (t < 1) {
              requestAnimationFrame(animateOrbScroll);
            } else {
              // Animation done — restore user input
              document.removeEventListener('touchmove', lockScroll);
              document.removeEventListener('wheel', lockScroll);
              window.__orbClickInProgress = false;
            }
          }
          requestAnimationFrame(animateOrbScroll);
        }
      });
    });
  }
  // Side navigator click → same robust scroll
  const sidenavLinksClick = document.querySelectorAll('.sidenav__link');
  sidenavLinksClick.forEach(link => {
    link.addEventListener('click', (e) => {
      const href = link.getAttribute('href');
      if (!href || !href.startsWith('#')) return;
      const target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      window.__autoScrollAfterDive = true;  // prevent dive interference
      window.__orbClickInProgress = true;   // protect the in-progress nav from reset+auto-dive
      window.__orbClickLockUntil = performance.now() + 1700;  // belt-and-suspenders timestamp lock
      const headerOffset = 80;
      const cellRect = target.getBoundingClientRect();
      const cellCenter = cellRect.top + window.scrollY + cellRect.height / 2;
      const viewportCenter = window.innerHeight / 2;
      const scrollTarget = cellCenter - viewportCenter + (headerOffset / 2);
      if (lenis) {
        lenis.scrollTo(scrollTarget, {
          duration: 1.4, lock: true, force: true,
          onComplete: () => { window.__orbClickInProgress = false; },
        });
      } else {
        const startY = window.scrollY;
        const distance = scrollTarget - startY;
        const duration = 1200;
        const startTime = performance.now();
        const lockScroll = (ev) => ev.preventDefault();
        document.addEventListener('touchmove', lockScroll, { passive: false });
        document.addEventListener('wheel', lockScroll, { passive: false });
        function animateNavScroll(now) {
          const t = Math.min(1, (now - startTime) / duration);
          const eased = t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
          window.scrollTo(0, startY + distance * eased);
          if (t < 1) {
            requestAnimationFrame(animateNavScroll);
          } else {
            document.removeEventListener('touchmove', lockScroll);
            document.removeEventListener('wheel', lockScroll);
            window.__orbClickInProgress = false;
          }
        }
        requestAnimationFrame(animateNavScroll);
      }
    });
  });

  // ============================================================================
  // CELL CONTENT REVEAL — adds .is-visible to cells when they scroll into view.
  // This is what makes the eyebrow / name / tagline / variants / CTA fade in.
  // Without this, all cell text stays at opacity 0 and is invisible.
  // ============================================================================
  const cellsForReveal = document.querySelectorAll('.cell');
  if (cellsForReveal.length > 0) {
    const cellObserver = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) e.target.classList.add('is-visible');
      });
    }, { threshold: 0.25, rootMargin: '0px 0px -10% 0px' });
    cellsForReveal.forEach(c => cellObserver.observe(c));
    __cleanupCallbacks.push(() => cellObserver.disconnect());
  }

  // ============================================================================
  // FLIP-TILT SECTIONS — interlude / teaser / cells rotate as they pass through.
  // Inner content rotates on rotateX based on section's distance from viewport
  // center. Plateau zone (±18% of viewport center) keeps content flat in middle.
  // ============================================================================
  const flipSections = Array.from(document.querySelectorAll('.flip-section'));
  function updateFlipTilts() {
    const wh = window.innerHeight;
    const isPhone = window.innerWidth < 768;
    // Mobile cards are smaller so they need a smaller plateau and larger max
    // rotation to feel as dramatic as desktop. Without this, the tilt feels muted.
    const PLATEAU = isPhone ? 0.04 : 0.18;
    const MAX_ROT = isPhone ? 75 : 45;
    flipSections.forEach(s => {
      const r = s.getBoundingClientRect();
      const inner = s.querySelector('.flip-inner');
      if (!inner) return;
      // Skip if completely offscreen
      if (r.bottom < -wh * 0.3 || r.top > wh * 1.3) {
        inner.style.setProperty('--flip-rot', '0deg');
        return;
      }
      const sectionCenter = r.top + r.height / 2;
      const viewportCenter = wh / 2;
      const offset = (sectionCenter - viewportCenter) / wh;
      const clamped = Math.max(-1.2, Math.min(1.2, offset));
      const absOffset = Math.abs(clamped);
      let rot;
      if (absOffset < PLATEAU) {
        rot = 0;
      } else {
        const beyond = (absOffset - PLATEAU) / (1.2 - PLATEAU);
        const eased = beyond < 0.5
          ? 2 * beyond * beyond
          : 1 - Math.pow(-2 * beyond + 2, 2) / 2;
        rot = Math.sign(clamped) * eased * MAX_ROT;
      }
      inner.style.setProperty('--flip-rot', rot.toFixed(1) + 'deg');
    });
  }

  // Master scroll handler — throttled with rAF
  let scrollTicking = false;
  function onScrollMaster() {
    if (!scrollTicking) {
      requestAnimationFrame(() => {
        updateFlipTilts();
        scrollTicking = false;
      });
      scrollTicking = true;
    }
  }
  _addListener(window, 'scroll', onScrollMaster, { passive: true });
  _addListener(window, 'resize', onScrollMaster, { passive: true });
  onScrollMaster(); // run once on init

})();

/* === COLLECTION-AWARE VISIBILITY ===
   Listens for 'unlawk-collection-change' from luxe-collection-explorer.
   When the active collection is anything other than 'original', this whole
   section is hidden (the DP coming-soon section will show in its place).
   Applies on BOTH desktop and mobile so the homepage flow stays consistent. */
(function () {
  var STORAGE_KEY = 'unlawk-active-collection';
  var EVENT_NAME = 'unlawk-collection-change';
  var TARGET_COLLECTION = 'original'; // this section belongs to OG

  var section = document.querySelector('.luxe-experience');
  if (!section) return;

  function applyVisibility(slug) {
    if (slug && slug !== TARGET_COLLECTION) {
      section.style.display = 'none';
    } else {
      section.style.display = '';
    }
  }

  // Initial state from sessionStorage, falling back to visible selector opener
  var initial = '';
  try { initial = sessionStorage.getItem(STORAGE_KEY) || ''; } catch (e) {}
  if (initial === '') {
    var openerEl = document.querySelector('.lce__opener[data-lce-active]');
    if (openerEl) {
      initial = openerEl.getAttribute('data-lce-active') || '';
    }
    if (initial === '') {
      var visibleOpener = document.querySelector('.lce__opener-view:not([hidden])');
      if (visibleOpener) {
        initial = visibleOpener.getAttribute('data-lce-opener-for') || '';
      }
    }
  }
  applyVisibility(initial);

  // Listen for changes from the selector
  document.addEventListener(EVENT_NAME, function (e) {
    if (!e.detail || !e.detail.slug) return;
    applyVisibility(e.detail.slug);
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxe-footer"] && !Shopify.designMode) return;
  try {
    
  // Klaviyo direct-subscribe handler. Activates only on forms with [data-lf-klaviyo].
  // Posts the email to Klaviyo's subscribe endpoint and shows in-form feedback.
  (function () {
    document.querySelectorAll('form[data-lf-klaviyo]').forEach(function (form) {
      if (form.dataset.lfBound === 'true') return;
      form.dataset.lfBound = 'true';

      form.addEventListener('submit', async function (e) {
        e.preventDefault();
        const listId = form.dataset.lfKlaviyoList;
        const successMsg = form.dataset.lfSuccessMsg || 'You are on the list ✓';
        const emailInput = form.querySelector('input[name="email"]');
        const btn = form.querySelector('button[type="submit"]');
        const feedback = form.querySelector('.luxe-footer__signup-feedback');
        if (!listId || !emailInput || !feedback) return;

        const email = (emailInput.value || '').trim();
        if (!email) {
          feedback.textContent = 'Please enter an email address.';
          feedback.className = 'luxe-footer__signup-feedback luxe-footer__signup-feedback--error';
          return;
        }

        const originalLabel = btn.querySelector('span') ? btn.querySelector('span').textContent : btn.textContent;
        if (btn.querySelector('span')) btn.querySelector('span').textContent = 'Sending…';
        btn.disabled = true;

        try {
          const body = new URLSearchParams();
          body.append('g', listId);
          body.append('email', email);
          body.append('$fields', 'email');
          await fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
            method: 'POST',
            mode: 'no-cors',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: body
          });
          // Klaviyo returns no-cors opaque response — assume success on no error
          feedback.textContent = successMsg;
          feedback.className = 'luxe-footer__signup-feedback luxe-footer__signup-feedback--success';
          emailInput.value = '';
        } catch (err) {
          feedback.textContent = 'Something went wrong. Please try again.';
          feedback.className = 'luxe-footer__signup-feedback luxe-footer__signup-feedback--error';
        } finally {
          if (btn.querySelector('span')) btn.querySelector('span').textContent = originalLabel;
          btn.disabled = false;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxe-globe"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__lgCleanup) {
    try { window.__lgCleanup(); } catch (e) {}
  }
  var __cleanup = [];
  window.__lgCleanup = function () {
    __cleanup.forEach(function (fn) { try { fn(); } catch (e) {} });
    __cleanup.length = 0;
  };

  var section = document.querySelector('.luxe-globe');
  if (!section) return;
  var canvasWrap = section.querySelector('#luxeGlobeCanvas');
  var hint = section.querySelector('#luxeGlobeHint');
  var panel = section.querySelector('#luxeGlobePanel');
  var panelContent = section.querySelector('#luxeGlobePanelContent');
  var panelClose = section.querySelector('#luxeGlobePanelClose');
  var pinsRaw = section.querySelector('#luxeGlobePins');
  if (!canvasWrap || !pinsRaw) return;

  var stockists = [];
  try {
    stockists = JSON.parse(pinsRaw.textContent);
    stockists = stockists.map(function (s) {
      var lat = parseFloat(s.lat);
      var lng = parseFloat(s.lng);
      if (isNaN(lat) || isNaN(lng)) return null;
      s.lat = lat;
      s.lng = lng;
      return s;
    }).filter(Boolean);
  } catch (e) { stockists = []; }

  // Group stockists by city, then by store_name within each city.
  // Same store with multiple locations = one card with multiple address rows.
  function buildCityGroups(items) {
    var byCity = {};
    var cityOrder = [];
    items.forEach(function (s) {
      var cityKey = (s.city || 'Unknown').trim().toLowerCase();
      if (!byCity[cityKey]) {
        byCity[cityKey] = {
          id: 'city-' + cityKey.replace(/[^a-z0-9]+/g, '-'),
          city: s.city || 'Unknown',
          province: s.province || '',
          country: s.country || '',
          lat: s.lat,
          lng: s.lng,
          stores: {},
          storeOrder: []
        };
        cityOrder.push(cityKey);
      }
      var city = byCity[cityKey];
      var storeKey = (s.store_name || 'Stockist').trim().toLowerCase();
      if (!city.stores[storeKey]) {
        city.stores[storeKey] = {
          id: city.id + '--' + storeKey.replace(/[^a-z0-9]+/g, '-'),
          name: s.store_name || 'Stockist',
          locations: []
        };
        city.storeOrder.push(storeKey);
      }
      city.stores[storeKey].locations.push(s);
    });
    // Flatten to array form for downstream use
    return cityOrder.map(function (ck) {
      var c = byCity[ck];
      c.storeList = c.storeOrder.map(function (sk) { return c.stores[sk]; });
      // Total location count for the city (for pin label "X locations")
      c.locationCount = c.storeList.reduce(function (n, st) { return n + st.locations.length; }, 0);
      return c;
    });
  }
  var cityGroups = buildCityGroups(stockists);

  // === Build the stockist list accordion ===
  var groupsContainer = section.querySelector('#luxeGlobeGroups');
  if (groupsContainer && cityGroups.length) {
    groupsContainer.innerHTML = '';  // clear noscript fallback
    cityGroups.forEach(function (group, idx) {
      var groupEl = document.createElement('div');
      groupEl.className = 'luxe-globe__group';
      groupEl.setAttribute('data-city-id', group.id);
      if (idx === 0) groupEl.classList.add('is-open');  // first group expanded by default

      var region = [group.province, group.country].filter(Boolean).join(', ');

      // Build store cards. A store can have 1 or many locations.
      // Single-location store → one "Get directions" button under the name.
      // Multi-location store → a list of locations, each with its own button.
      var storesHTML = group.storeList.map(function (store) {
        var locationsHTML = store.locations.map(function (loc, locIdx) {
          var label = (store.locations.length === 1)
            ? (loc.url_label || 'Get directions')
            : (loc.location_label || ('Location ' + (locIdx + 1)));
          var btn = loc.url
            ? '<a class="luxe-globe__loc-btn" href="' + loc.url + '" target="_blank" rel="noopener">'
              + '<span class="luxe-globe__loc-btn-label">' + label + '</span>'
              + '<span class="luxe-globe__loc-btn-arrow">&rarr;</span>'
              + '</a>'
            : '<span class="luxe-globe__loc-btn luxe-globe__loc-btn--inactive">' + label + '</span>';
          return '<div class="luxe-globe__loc">' + btn + '</div>';
        }).join('');

        var countLabel = (store.locations.length > 1)
          ? '<span class="luxe-globe__store-count">' + store.locations.length + ' locations</span>'
          : '';

        return '<div class="luxe-globe__store">'
          + '<div class="luxe-globe__store-header">'
          + '<h3 class="luxe-globe__store-name">' + store.name + '</h3>'
          + countLabel
          + '</div>'
          + '<div class="luxe-globe__store-locs">' + locationsHTML + '</div>'
          + '</div>';
      }).join('');

      groupEl.innerHTML =
        '<button type="button" class="luxe-globe__group-header" aria-expanded="' + (idx === 0 ? 'true' : 'false') + '">'
        + '<span class="luxe-globe__group-city">' + group.city
        + (region ? '<span class="luxe-globe__group-region">' + region + '</span>' : '')
        + '</span>'
        + '<span class="luxe-globe__group-meta">'
        + '<span class="luxe-globe__group-count">' + group.locationCount + ' ' + (group.locationCount === 1 ? 'location' : 'locations') + '</span>'
        + '<span class="luxe-globe__group-toggle">+</span>'
        + '</span>'
        + '</button>'
        + '<div class="luxe-globe__group-stockists">' + storesHTML + '</div>';

      var btn = groupEl.querySelector('.luxe-globe__group-header');
      btn.addEventListener('click', function () {
        var wasOpen = groupEl.classList.contains('is-open');
        groupEl.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', wasOpen ? 'false' : 'true');
        if (!wasOpen && window.__lgSpinToCity) {
          window.__lgSpinToCity(group.id);
        }
      });

      groupsContainer.appendChild(groupEl);
    });
  }

  function closePanel() {
    if (!panel) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    if (window.__lgActivePin) {
      var prev = window.__lgPinMeshes && window.__lgPinMeshes[window.__lgActivePin];
      if (prev && prev.userData) prev.userData.isActive = false;
      window.__lgActivePin = null;
    }
  }
  function openPanel(group, mesh) {
    if (!panel || !panelContent) return;
    var region = [group.province, group.country].filter(Boolean).join(', ');
    var storesHTML = group.storeList.map(function (store) {
      var locationsHTML = store.locations.map(function (loc, locIdx) {
        var label = (store.locations.length === 1)
          ? (loc.url_label || 'Get directions')
          : (loc.location_label || ('Location ' + (locIdx + 1)));
        return loc.url
          ? '<a class="luxe-globe__panel-loc-btn" href="' + loc.url + '" target="_blank" rel="noopener">'
            + '<span>' + label + '</span>'
            + '<span class="luxe-globe__panel-loc-btn-arrow">&rarr;</span>'
            + '</a>'
          : '<span class="luxe-globe__panel-loc-btn luxe-globe__panel-loc-btn--inactive">' + label + '</span>';
      }).join('');

      var countLabel = (store.locations.length > 1)
        ? '<div class="luxe-globe__panel-store-count">' + store.locations.length + ' locations</div>'
        : '';

      return '<div class="luxe-globe__panel-store">'
        + '<div class="luxe-globe__panel-store-name">' + store.name + '</div>'
        + countLabel
        + '<div class="luxe-globe__panel-store-locs">' + locationsHTML + '</div>'
        + '</div>';
    }).join('');

    panelContent.innerHTML =
      '<div class="luxe-globe__panel-eyebrow">UNLAWK &middot; Stockist</div>'
      + '<h2 class="luxe-globe__panel-city">' + (group.city || '') + '</h2>'
      + (region ? '<p class="luxe-globe__panel-country">' + region + '</p>' : '')
      + '<div class="luxe-globe__panel-rule"></div>'
      + storesHTML;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    if (mesh && mesh.userData) {
      mesh.userData.isActive = true;
      window.__lgActivePin = group.id;
    }
    var listGroup = section.querySelector('[data-city-id="' + group.id + '"]');
    if (listGroup) {
      section.querySelectorAll('.luxe-globe__group').forEach(function (g) {
        if (g !== listGroup) g.classList.remove('is-open');
      });
      listGroup.classList.add('is-open');
    }
  }
  if (panelClose) {
    panelClose.addEventListener('click', closePanel);
    __cleanup.push(function () { panelClose.removeEventListener('click', closePanel); });
  }

  // === Async loader for CDN deps ===
  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      // Skip if already loaded
      if (src.indexOf('three.min.js') !== -1 && window.THREE) { resolve(); return; }
      if (src.indexOf('topojson-client') !== -1 && window.topojson) { resolve(); return; }
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.onload = function () { resolve(); };
      s.onerror = function () { reject(new Error('Failed to load ' + src)); };
      document.head.appendChild(s);
    });
  }

  // === Lat/lng → 3D Cartesian on a sphere of given radius ===
  function latLngToVec3(lat, lng, radius) {
    var phi = (90 - lat) * Math.PI / 180;
    var theta = (lng + 180) * Math.PI / 180;
    return {
      x: -radius * Math.sin(phi) * Math.cos(theta),
      y:  radius * Math.cos(phi),
      z:  radius * Math.sin(phi) * Math.sin(theta)
    };
  }

  // === The actual globe build ===
  function buildGlobe() {
    if (!window.THREE) return;
    var THREE = window.THREE;
    var width = canvasWrap.clientWidth;
    var height = canvasWrap.clientHeight;
    if (!width || !height) return;

    var scene = new THREE.Scene();
    var camera = new THREE.PerspectiveCamera(40, width / height, 0.1, 1000);
    camera.position.set(0, 0, 5);

    var renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    renderer.setSize(width, height);
    canvasWrap.appendChild(renderer.domElement);

    // Lighting — strong ambient + soft hemispheric so the globe is evenly lit
    // from all angles. Avoids the "fixed bright spot" effect where a directional
    // light creates a stationary highlight that doesn't move with the rotating
    // continents (which feels disconnected since the earth itself appears to
    // generate light, not receive it from a fixed sun).
    var amb = new THREE.AmbientLight(0xffffff, 1.0);
    scene.add(amb);
    var hemi = new THREE.HemisphereLight(0xfff5dd, 0x6080a0, 0.55);
    scene.add(hemi);

    var globeGroup = new THREE.Group();
    scene.add(globeGroup);

    // === Glass sphere ===
    var GLOBE_RADIUS = 1.4;
    var globeGeo = new THREE.SphereGeometry(GLOBE_RADIUS, 64, 48);
    var tintColor = (section.style.getPropertyValue('--lg-globe-tint') || '#0e1a1f').trim();
    var globeMat = new THREE.MeshPhysicalMaterial({
      color: new THREE.Color(tintColor),
      roughness: 0.55,        // matte enough that no harsh highlight forms
      metalness: 0.05,
      transmission: 0.20,
      thickness: 0.8,
      ior: 1.45,
      transparent: true,
      opacity: 0.95,
      side: THREE.FrontSide
    });
    var globe = new THREE.Mesh(globeGeo, globeMat);
    globeGroup.add(globe);

    // Subtle inner darker sphere for depth
    var innerGeo = new THREE.SphereGeometry(GLOBE_RADIUS * 0.985, 48, 36);
    var innerMat = new THREE.MeshLambertMaterial({
      color: new THREE.Color(tintColor).multiplyScalar(0.7),
      transparent: true,
      opacity: 0.85,
    });
    var inner = new THREE.Mesh(innerGeo, innerMat);
    globeGroup.add(inner);

    // Outer atmosphere glow — larger transparent sphere with additive blending
    var atmGeo = new THREE.SphereGeometry(GLOBE_RADIUS * 1.06, 48, 36);
    var atmMat = new THREE.MeshBasicMaterial({
      color: 0xc9a84c,
      transparent: true,
      opacity: 0.10,
      side: THREE.BackSide,
      blending: THREE.AdditiveBlending
    });
    var atm = new THREE.Mesh(atmGeo, atmMat);
    globeGroup.add(atm);

    // Inner atmosphere — closer to surface, slightly warmer for layered glow
    var atm2Geo = new THREE.SphereGeometry(GLOBE_RADIUS * 1.02, 48, 36);
    var atm2Mat = new THREE.MeshBasicMaterial({
      color: 0xe8c878,
      transparent: true,
      opacity: 0.06,
      side: THREE.BackSide,
      blending: THREE.AdditiveBlending
    });
    var atm2 = new THREE.Mesh(atm2Geo, atm2Mat);
    globeGroup.add(atm2);

    // === Pins ===
    var pinMeshes = {};
    window.__lgPinMeshes = pinMeshes;
    var goldColor = new THREE.Color(0xc9a84c);
    var goldBright = new THREE.Color(0xe8c878);

    cityGroups.forEach(function (group) {
      var pos = latLngToVec3(group.lat, group.lng, GLOBE_RADIUS);

      // Inner solid bright dot — the pin itself
      var dotGeo = new THREE.SphereGeometry(0.03, 16, 12);
      var dotMat = new THREE.MeshBasicMaterial({ color: goldBright });
      var dot = new THREE.Mesh(dotGeo, dotMat);
      dot.position.set(pos.x, pos.y, pos.z);
      dot.userData = { group: group, isActive: false };

      // Inner halo ring (close to pin, brighter)
      var haloPos = latLngToVec3(group.lat, group.lng, GLOBE_RADIUS + 0.001);
      var haloGeo = new THREE.RingGeometry(0.038, 0.072, 36);
      var haloMat = new THREE.MeshBasicMaterial({
        color: goldColor,
        transparent: true,
        opacity: 0.7,
        side: THREE.DoubleSide,
        blending: THREE.AdditiveBlending,
        depthWrite: false
      });
      var halo = new THREE.Mesh(haloGeo, haloMat);
      halo.position.set(haloPos.x, haloPos.y, haloPos.z);
      halo.lookAt(haloPos.x * 2, haloPos.y * 2, haloPos.z * 2);
      halo.userData = { group: group, isHalo: true };

      // Outer corona — larger, fainter, slow-pulse counter-rhythm
      var coronaGeo = new THREE.RingGeometry(0.090, 0.150, 48);
      var coronaMat = new THREE.MeshBasicMaterial({
        color: goldColor,
        transparent: true,
        opacity: 0.22,
        side: THREE.DoubleSide,
        blending: THREE.AdditiveBlending,
        depthWrite: false
      });
      var corona = new THREE.Mesh(coronaGeo, coronaMat);
      corona.position.set(haloPos.x, haloPos.y, haloPos.z);
      corona.lookAt(haloPos.x * 2, haloPos.y * 2, haloPos.z * 2);
      corona.userData = { group: group, isCorona: true };

      // Subtle light cone rising from the pin. Wider at base, narrower at tip.
      // Vertex colors give a fade-out gradient (bright at base → invisible at top).
      var CONE_HEIGHT = 0.32;
      var coneGeo = new THREE.CylinderGeometry(0.003, 0.024, CONE_HEIGHT, 16, 1, true);
      // Apply vertex colors: bottom row bright, top row faded
      var posAttr = coneGeo.attributes.position;
      var colors = [];
      for (var v = 0; v < posAttr.count; v++) {
        var y = posAttr.getY(v);
        // y ranges from -CONE_HEIGHT/2 (bottom) to +CONE_HEIGHT/2 (top)
        var t = (y + CONE_HEIGHT / 2) / CONE_HEIGHT;  // 0 at base, 1 at tip
        // Bright gold at base, fading to nothing at tip
        var brightness = 1.0 - t;
        colors.push(0.91 * brightness, 0.78 * brightness, 0.47 * brightness);
      }
      coneGeo.setAttribute('color', new THREE.Float32BufferAttribute(colors, 3));
      var coneMat = new THREE.MeshBasicMaterial({
        vertexColors: true,
        transparent: true,
        opacity: 0.55,
        side: THREE.DoubleSide,
        blending: THREE.AdditiveBlending,
        depthWrite: false
      });
      var beam = new THREE.Mesh(coneGeo, coneMat);
      // Position cone with its base at the globe surface, pointing outward.
      // The cylinder geometry's Y axis is the height axis. We want that axis to
      // point radially outward from globe center.
      var beamCenter = latLngToVec3(group.lat, group.lng, GLOBE_RADIUS + CONE_HEIGHT / 2);
      beam.position.set(beamCenter.x, beamCenter.y, beamCenter.z);
      beam.lookAt(beamCenter.x * 2, beamCenter.y * 2, beamCenter.z * 2);
      beam.rotateX(Math.PI / 2);  // align cylinder Y-axis with the outward (now -Z) direction
      beam.userData = { group: group, isBeam: true };

      // Larger invisible hit sphere for easier clicking
      var hitGeo = new THREE.SphereGeometry(0.10, 12, 10);
      var hitMat = new THREE.MeshBasicMaterial({ visible: false });
      var hit = new THREE.Mesh(hitGeo, hitMat);
      hit.position.set(pos.x, pos.y, pos.z);
      hit.userData = { group: group, isHit: true };

      globeGroup.add(dot);
      globeGroup.add(halo);
      globeGroup.add(corona);
      globeGroup.add(beam);
      globeGroup.add(hit);
      pinMeshes[group.id] = { dot: dot, halo: halo, corona: corona, beam: beam, hit: hit, basePos: pos };
    });

    // === Continents from world-atlas TopoJSON ===
    function buildContinentLines(landGeometry) {
      if (!landGeometry || !landGeometry.coordinates) return;
      var positions = [];

      function addRing(coords) {
        for (var i = 0; i < coords.length - 1; i++) {
          var a = coords[i];
          var b = coords[i + 1];
          var pa = latLngToVec3(a[1], a[0], GLOBE_RADIUS * 1.001);
          var pb = latLngToVec3(b[1], b[0], GLOBE_RADIUS * 1.001);
          positions.push(pa.x, pa.y, pa.z, pb.x, pb.y, pb.z);
        }
      }
      function walkGeometry(geom) {
        if (!geom) return;
        if (geom.type === 'Polygon') {
          geom.coordinates.forEach(addRing);
        } else if (geom.type === 'MultiPolygon') {
          geom.coordinates.forEach(function (poly) { poly.forEach(addRing); });
        } else if (geom.type === 'GeometryCollection') {
          geom.geometries.forEach(walkGeometry);
        }
      }
      walkGeometry(landGeometry);

      if (!positions.length) return;
      var geo = new THREE.BufferGeometry();
      geo.setAttribute('position', new THREE.Float32BufferAttribute(positions, 3));
      var mat = new THREE.LineBasicMaterial({
        color: goldColor,
        transparent: true,
        opacity: 0.42,
        depthWrite: false
      });
      var lines = new THREE.LineSegments(geo, mat);
      globeGroup.add(lines);
    }

    // === Drag-to-rotate + auto-rotate + momentum ===
    var rotation = { x: 0.25, y: 0 };
    var velocity = { x: 0, y: 0.0024 };  // base auto-rotate speed
    var dragging = false;
    var lastPointer = { x: 0, y: 0 };
    var lastInteractionTime = performance.now();
    var dragStartPos = null;
    var hadDragMovement = false;
    // Rolling buffer of recent movement samples — used to compute release velocity
    // from the last ~80ms of movement instead of a single frame's delta. This makes
    // momentum feel right even when the final frame's delta is small (e.g. user
    // slowed slightly before release but had a strong flick mid-drag).
    var moveSamples = [];

    function isInsideGlobeCircle(clientX, clientY) {
      var rect = canvasWrap.getBoundingClientRect();
      var cx = rect.left + rect.width / 2;
      var cy = rect.top + rect.height / 2;
      var dx = clientX - cx;
      var dy = clientY - cy;
      var r = Math.min(rect.width, rect.height) * 0.46;
      return (dx * dx + dy * dy) <= (r * r);
    }

    function onPointerDown(e) {
      var pt = (e.touches && e.touches[0]) ? e.touches[0] : e;
      if (!isInsideGlobeCircle(pt.clientX, pt.clientY)) return;
      dragging = true;
      hadDragMovement = false;
      dragStartPos = { x: pt.clientX, y: pt.clientY };
      lastPointer.x = pt.clientX;
      lastPointer.y = pt.clientY;
      lastInteractionTime = performance.now();
      moveSamples = [];   // reset sample buffer for this drag
      velocity.x = 0;
      velocity.y = 0;
    }
    function onPointerMove(e) {
      if (!dragging) return;
      var pt = (e.touches && e.touches[0]) ? e.touches[0] : e;
      var dx = pt.clientX - lastPointer.x;
      var dy = pt.clientY - lastPointer.y;
      lastPointer.x = pt.clientX;
      lastPointer.y = pt.clientY;
      if (dragStartPos && (Math.abs(pt.clientX - dragStartPos.x) > 4 || Math.abs(pt.clientY - dragStartPos.y) > 4)) {
        hadDragMovement = true;
      }
      rotation.y += dx * 0.005;
      rotation.x += dy * 0.005;
      rotation.x = Math.max(-Math.PI / 2.4, Math.min(Math.PI / 2.4, rotation.x));
      // Record this sample with timestamp for velocity calc on release
      var now = performance.now();
      moveSamples.push({ t: now, dx: dx, dy: dy });
      // Keep only the last 80ms of samples
      var cutoff = now - 80;
      while (moveSamples.length && moveSamples[0].t < cutoff) moveSamples.shift();
      lastInteractionTime = now;
      if (e.cancelable) e.preventDefault();
    }
    function onPointerUp() {
      if (!dragging) return;
      // Compute release velocity from the rolling sample window. Sum recent
      // dx/dy and divide by elapsed time to get pixels/ms; convert to
      // radians/frame at 60fps. This way momentum reflects the user's actual
      // intent (their flick), not just whatever tiny frame happened to land last.
      if (moveSamples.length >= 2) {
        var first = moveSamples[0];
        var last = moveSamples[moveSamples.length - 1];
        var elapsed = Math.max(16, last.t - first.t);
        var totalDx = 0, totalDy = 0;
        for (var i = 0; i < moveSamples.length; i++) {
          totalDx += moveSamples[i].dx;
          totalDy += moveSamples[i].dy;
        }
        // px/ms × 16ms/frame × rad/px → rad/frame at 60fps
        velocity.y = (totalDx / elapsed) * 16 * 0.005;
        velocity.x = (totalDy / elapsed) * 16 * 0.005;
        // Cap maximum so a really fast flick doesn't spin like a top
        var MAX_V = 0.08;
        velocity.y = Math.max(-MAX_V, Math.min(MAX_V, velocity.y));
        velocity.x = Math.max(-MAX_V, Math.min(MAX_V, velocity.x));
      }
      dragging = false;
      dragStartPos = null;
      moveSamples = [];
    }

    canvasWrap.addEventListener('pointerdown', onPointerDown, { passive: false });
    canvasWrap.addEventListener('pointermove', onPointerMove, { passive: false });
    window.addEventListener('pointerup', onPointerUp);
    canvasWrap.addEventListener('touchstart', onPointerDown, { passive: false });
    canvasWrap.addEventListener('touchmove', onPointerMove, { passive: false });
    window.addEventListener('touchend', onPointerUp, { passive: true });
    __cleanup.push(function () {
      canvasWrap.removeEventListener('pointerdown', onPointerDown);
      canvasWrap.removeEventListener('pointermove', onPointerMove);
      window.removeEventListener('pointerup', onPointerUp);
      canvasWrap.removeEventListener('touchstart', onPointerDown);
      canvasWrap.removeEventListener('touchmove', onPointerMove);
      window.removeEventListener('touchend', onPointerUp);
    });

    // === Click handling — raycaster on hit spheres ===
    var raycaster = new THREE.Raycaster();
    var mouse = new THREE.Vector2();
    function onClick(e) {
      // Suppress click if the user dragged
      if (hadDragMovement) { hadDragMovement = false; return; }
      var rect = canvasWrap.getBoundingClientRect();
      mouse.x = ((e.clientX - rect.left) / rect.width) * 2 - 1;
      mouse.y = -((e.clientY - rect.top) / rect.height) * 2 + 1;
      raycaster.setFromCamera(mouse, camera);
      var hits = Object.keys(pinMeshes).map(function (k) { return pinMeshes[k].hit; });
      var intersects = raycaster.intersectObjects(hits, false);
      if (intersects.length > 0) {
        var group = intersects[0].object.userData.group;
        var mesh = pinMeshes[group.id];
        var pinPos = latLngToVec3(group.lat, group.lng, 1);
        var targetY = Math.atan2(pinPos.x, pinPos.z);
        var targetX = -Math.asin(pinPos.y);
        rotation.y = -targetY;
        rotation.x = targetX * 0.4;
        openPanel(group, mesh.dot);
      }
    }
    canvasWrap.addEventListener('click', onClick);
    __cleanup.push(function () { canvasWrap.removeEventListener('click', onClick); });

    // === Resize ===
    function onResize() {
      var w = canvasWrap.clientWidth;
      var h = canvasWrap.clientHeight;
      if (!w || !h) return;
      camera.aspect = w / h;
      camera.updateProjectionMatrix();
      renderer.setSize(w, h);
    }
    window.addEventListener('resize', onResize);
    __cleanup.push(function () { window.removeEventListener('resize', onResize); });

    // === Animation loop ===
    var rafId;
    var t0 = performance.now();
    function tick() {
      var now = performance.now();
      var idle = now - lastInteractionTime;
      if (dragging) {
        // velocity is being tracked inside onPointerMove; rotation is updated there
      } else {
        // After release: keep spinning with the velocity user gave it.
        // Decay slowly (0.985 per frame ≈ 4-second tail) so the momentum reads
        // as deliberate. Vertical motion decays a bit faster than horizontal
        // so the globe doesn't keep wobbling up/down forever.
        var DECAY_Y = 0.985;
        var DECAY_X = 0.96;
        // Once velocity is below the auto-rotate baseline, blend gently into auto-rotate
        var AUTO_SPEED = 0.0022;
        rotation.y += velocity.y;
        rotation.x += velocity.x;
        rotation.x = Math.max(-Math.PI / 2.4, Math.min(Math.PI / 2.4, rotation.x));
        velocity.y *= DECAY_Y;
        velocity.x *= DECAY_X;
        // Once user has been idle for a beat AND momentum has decayed, pull
        // velocity.y back up toward the auto-rotate baseline (in the direction
        // they were spinning, OR default direction if velocity is near zero).
        if (idle > 800) {
          var ramp = Math.min(1, (idle - 800) / 1500);
          var targetY = (Math.abs(velocity.y) < 0.0005)
            ? AUTO_SPEED                  // user stopped → resume default direction
            : Math.sign(velocity.y) * AUTO_SPEED;  // continue user's direction
          velocity.y += (targetY - velocity.y) * 0.02 * ramp;
          // Slowly ease vertical rotation back to a subtle tilt
          rotation.x += (0.25 - rotation.x) * 0.001;
        }
      }
      globeGroup.rotation.y = rotation.y;
      globeGroup.rotation.x = rotation.x;

      // Pulse halo + corona — counter-phased for depth
      var pulseFast = 0.5 + Math.sin((now - t0) * 0.003) * 0.25;
      var pulseSlow = 0.5 + Math.sin((now - t0) * 0.0018 + Math.PI * 0.5) * 0.35;
      var beamPulse = 0.45 + Math.sin((now - t0) * 0.0024) * 0.25;
      Object.keys(pinMeshes).forEach(function (k) {
        var p = pinMeshes[k];
        var active = p.dot.userData.isActive;
        if (p.halo && p.halo.material) {
          p.halo.material.opacity = active ? 0.95 : pulseFast * 0.7;
        }
        if (p.corona && p.corona.material) {
          p.corona.material.opacity = active ? 0.45 : pulseSlow * 0.32;
          // Corona slowly grows/shrinks for breathing effect
          var coronaScale = active ? 1.15 : (1.0 + pulseSlow * 0.08);
          p.corona.scale.set(coronaScale, coronaScale, coronaScale);
        }
        if (p.beam && p.beam.material) {
          p.beam.material.opacity = active ? 0.7 : beamPulse * 0.55;
        }
      });

      renderer.render(scene, camera);
      rafId = requestAnimationFrame(tick);
    }
    // Expose: list group click → spin globe to its city
    window.__lgSpinToCity = function (cityId) {
      var mesh = pinMeshes[cityId];
      if (!mesh) return;
      var basePos = mesh.basePos;
      var pinPos = { x: basePos.x / GLOBE_RADIUS, y: basePos.y / GLOBE_RADIUS, z: basePos.z / GLOBE_RADIUS };
      var targetY = Math.atan2(pinPos.x, pinPos.z);
      var targetX = -Math.asin(pinPos.y);
      rotation.y = -targetY;
      rotation.x = targetX * 0.4;
      lastInteractionTime = performance.now();
    };

    tick();
    __cleanup.push(function () {
      if (rafId) cancelAnimationFrame(rafId);
      try { renderer.dispose(); } catch (e) {}
      try { canvasWrap.removeChild(renderer.domElement); } catch (e) {}
    });

    // Reveal hint after a beat
    setTimeout(function () { if (hint) hint.classList.add('is-visible'); }, 1500);

    // === Load TopoJSON for continents (separate, non-blocking) ===
    fetch('https://unpkg.com/world-atlas@2/land-110m.json')
      .then(function (r) { return r.json(); })
      .then(function (topology) {
        if (!window.topojson) return;
        var landGeo = window.topojson.feature(topology, topology.objects.land);
        // landGeo can be a single Feature or a FeatureCollection
        if (landGeo.type === 'FeatureCollection') {
          landGeo.features.forEach(function (f) { buildContinentLines(f.geometry); });
        } else if (landGeo.geometry) {
          buildContinentLines(landGeo.geometry);
        } else {
          buildContinentLines(landGeo);
        }
      })
      .catch(function () { /* silently degrade — globe still works without continents */ });
  }

  // === Lazy init when section enters viewport ===
  function init() {
    Promise.all([
      loadScript('https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js'),
      loadScript('https://unpkg.com/topojson-client@3/dist/topojson-client.min.js')
    ]).then(function () {
      buildGlobe();
    }).catch(function (err) {
      console.warn('luxe-globe deps failed:', err);
    });
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          io.disconnect();
          init();
        }
      });
    }, { rootMargin: '200px' });
    io.observe(section);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxe-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // === Custom cursor ===
    // Two elements (dot + ring) follow the mouse. mix-blend-mode: difference (set in CSS)
    // makes them readable on both light and dark backgrounds. On touch devices, this
    // block bails out early — the elements are also hidden via @media in CSS.
    const cursorDot = document.getElementById('cursorDot');
    const cursorRing = document.getElementById('cursorRing');
    const isTouchDevice = window.matchMedia('(hover: none), (pointer: coarse)').matches;
    if (!isTouchDevice && cursorDot && cursorRing) {
      document.addEventListener('mousemove', (e) => {
        const x = e.clientX, y = e.clientY;
        cursorDot.style.transform = `translate(${x}px, ${y}px) translate(-50%, -50%)`;
        cursorRing.style.transform = `translate(${x}px, ${y}px) translate(-50%, -50%)`;
      });
      document.addEventListener('mouseleave', () => {
        cursorDot.classList.add('is-hidden');
        cursorRing.classList.add('is-hidden');
      });
      document.addEventListener('mouseenter', () => {
        cursorDot.classList.remove('is-hidden');
        cursorRing.classList.remove('is-hidden');
      });
      // Hover-state ring grow on interactive elements. Use event delegation
      // on the document so dynamically-added elements (like the cells loaded
      // during scroll, or future product page elements) also work.
      const isInteractive = (el) => {
        if (!el || !el.matches) return false;
        return el.matches('a, button, input, textarea, select, [role="button"], .orb, .luxe-header__menu-card, .luxe-header__mega-card, .cell, .orb-card, [data-luxe-clickable]');
      };
      document.addEventListener('mouseover', (e) => {
        // Walk up to the nearest interactive ancestor (up to 4 levels)
        let el = e.target;
        for (let i = 0; i < 4 && el; i++) {
          if (isInteractive(el)) { cursorRing.classList.add('is-hover'); return; }
          el = el.parentElement;
        }
      });
      document.addEventListener('mouseout', (e) => {
        let el = e.target;
        for (let i = 0; i < 4 && el; i++) {
          if (isInteractive(el)) { cursorRing.classList.remove('is-hover'); return; }
          el = el.parentElement;
        }
      });
    }

    // === Lazy card images (mega menu + side panel) ===
    // The card images live inside panels that are hidden until a menu opens, so
    // they are kept off the initial page load: each <img> carries its URL in
    // data-lh-card-src and gets a real src on first menu intent (hover / focus /
    // touch on the header bar, or any menu open). As a safety net they are also
    // warmed up once the page has fully loaded and the browser is idle, so the
    // cards are never empty when a menu opens.
    let cardImagesWanted = false;
    function loadCardImages() {
      cardImagesWanted = true;
      document.querySelectorAll('img[data-lh-card-src]').forEach((img) => {
        img.src = img.getAttribute('data-lh-card-src');
        img.removeAttribute('data-lh-card-src');
      });
    }
    // Theme editor: a re-rendered header gets fresh <img data-lh-card-src> nodes.
    document.addEventListener('shopify:section:load', () => { if (cardImagesWanted) loadCardImages(); });
    const headerBar = document.querySelector('.luxe-header__topbar');
    if (headerBar) {
      ['pointerenter', 'touchstart', 'focusin'].forEach((type) => {
        headerBar.addEventListener(type, loadCardImages, { passive: true, once: true });
      });
    }
    (function warmUpCardImages() {
      const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (conn && conn.saveData) return;   // Data Saver: load on demand only
      const idle = () => {
        if ('requestIdleCallback' in window) window.requestIdleCallback(loadCardImages, { timeout: 4000 });
        else setTimeout(loadCardImages, 1500);
      };
      if (document.readyState === 'complete') idle();
      else window.addEventListener('load', idle, { once: true });
    })();

    // === Side panel (hamburger) ===
    const menuBtn = document.getElementById('luxeMenuBtn');
    const menuOverlay = document.getElementById('luxeMenuOverlay');
    const menuCloseBtn = document.getElementById('luxeMenuCloseBtn');
    if (menuBtn && menuOverlay && menuCloseBtn) {
      const menuPanel = menuOverlay.querySelector('.luxe-header__menu-panel');
      let menuCloseTimer = null;

      const openMenu = () => {
        clearTimeout(menuCloseTimer);
        loadCardImages();
        menuOverlay.classList.add('is-open');
        menuOverlay.setAttribute('aria-hidden', 'false');
        menuBtn.setAttribute('aria-expanded', 'true');
      };
      const closeMenuNow = () => {
        clearTimeout(menuCloseTimer);
        menuOverlay.classList.remove('is-open');
        menuOverlay.setAttribute('aria-hidden', 'true');
        menuBtn.setAttribute('aria-expanded', 'false');
      };
      const closeMenuSoon = () => {
        clearTimeout(menuCloseTimer);
        menuCloseTimer = setTimeout(closeMenuNow, 280);
      };
      const cancelMenuClose = () => { clearTimeout(menuCloseTimer); };

      menuBtn.addEventListener('mouseenter', openMenu);
      menuBtn.addEventListener('mouseleave', closeMenuSoon);
      if (menuPanel) {
        menuPanel.addEventListener('mouseenter', cancelMenuClose);
        menuPanel.addEventListener('mouseleave', closeMenuSoon);
      }
      // Click handler — works on desktop + most mobile browsers
      menuBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        openMenu();
      });
      // Touch fallback for iOS Safari where click events sometimes fail or
      // mouseenter doesn't fire on first tap. Touchend is the reliable trigger.
      menuBtn.addEventListener('touchend', (e) => {
        e.preventDefault();  // prevent the synthesized click from firing twice
        e.stopPropagation();
        openMenu();
      }, { passive: false });
      menuCloseBtn.addEventListener('click', closeMenuNow);
      menuCloseBtn.addEventListener('touchend', (e) => {
        e.preventDefault();
        closeMenuNow();
      }, { passive: false });
      menuOverlay.addEventListener('click', (e) => { if (e.target === menuOverlay) closeMenuNow(); });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && menuOverlay.classList.contains('is-open')) closeMenuNow();
      });

      // === Fade-jump-fade navigation helper (shared by side panel + mega menu cards) ===
      // Returns true if we handled the click manually (fade transition on same page);
      // false if browser should do default navigation (cross-page link, no target found).
      function performFadeJump(card, closeMenuFn) {
        const href = card.getAttribute('href');
        if (!href) return false;
        if (!(href.startsWith('/#') || href.startsWith('#'))) {
          // External / cross-page link — close menu, let browser navigate
          if (closeMenuFn) closeMenuFn();
          return false;
        }
        const hashPart = href.replace(/^\//, '');
        const target = document.querySelector(hashPart);
        if (!target) {
          // Hash exists but target isn't on this page (e.g. /#luxe-dp on a product page).
          // Let browser navigate to homepage with hash.
          if (closeMenuFn) closeMenuFn();
          return false;
        }
        // Target exists — close menu first, then fade-jump-fade.
        if (closeMenuFn) closeMenuFn();
        setTimeout(() => {
          let fade = document.getElementById('luxeNavFade');
          if (!fade) {
            fade = document.createElement('div');
            fade.id = 'luxeNavFade';
            fade.style.cssText = 'position:fixed;inset:0;background:#0a0c0c;z-index:9998;opacity:0;pointer-events:none;transition:opacity 600ms ease;';
            document.body.appendChild(fade);
          }
          window.__autoScrollAfterDive = true;
          // Mark intro as skipped — user explicitly chose to navigate to a section,
          // they don't want manifesto playing if they later scroll back up.
          window.__skipIntro = true;
          window.__manifestoRevealed = true;
          window.__manifestoComplete = true;
          window.__boomTriggered = true;
          window.__boomGateOpen = true;
          window.__boomReady = true;
          window.__carouselGateOpen = true;
          window.__carouselReady = true;
          try { sessionStorage.setItem('luxe-intro-played', '1'); } catch (e) {}
          // Hide manifesto + giant brand mark immediately so they don't appear if user scrolls up
          var cManifesto = document.getElementById('constellationManifesto');
          var cMark = document.getElementById('constellationMark');
          if (cManifesto) cManifesto.style.opacity = '0';
          if (cMark) cMark.style.opacity = '0';
          // Light up all manifesto words so they look pre-revealed if user does see them
          document.querySelectorAll('.manifesto .word').forEach(function (w) { w.classList.add('lit'); });
          // 1) Fade in to black
          fade.style.pointerEvents = 'auto';
          fade.style.opacity = '1';
          // 2) After fade complete, instant-scroll + fade out
          setTimeout(() => {
            const headerOffset = 80;
            const cellRect = target.getBoundingClientRect();
            const cellCenter = cellRect.top + window.scrollY + cellRect.height / 2;
            const viewportCenter = window.innerHeight / 2;
            const scrollTarget = cellCenter - viewportCenter + (headerOffset / 2);
            window.scrollTo(0, scrollTarget);
            setTimeout(() => {
              fade.style.opacity = '0';
              setTimeout(() => { fade.style.pointerEvents = 'none'; }, 600);
            }, 200);
          }, 600);
        }, 280);
        return true;
      }

      // Side panel cards (mobile hamburger) — attach fade-jump
      const menuCards = menuOverlay.querySelectorAll('.luxe-header__menu-card');
      menuCards.forEach(card => {
        card.addEventListener('click', (e) => {
          if (performFadeJump(card, closeMenuNow)) e.preventDefault();
        });
        card.addEventListener('touchend', (e) => {
          const href = card.getAttribute('href');
          if (!href) return;
          if (href.startsWith('/#') || href.startsWith('#')) {
            const hashPart = href.replace(/^\//, '');
            const target = document.querySelector(hashPart);
            if (target) {
              e.preventDefault();
              performFadeJump(card, closeMenuNow);
            }
          }
        }, { passive: false });
      });

      // Side panel text nav links — close menu when tapped
      const menuNavLinks = menuOverlay.querySelectorAll('.luxe-header__menu-nav a, .luxe-header__menu-footer a');
      menuNavLinks.forEach(link => {
        link.addEventListener('click', () => closeMenuNow());
      });
    }

    // === Mega menu cards (desktop dropdown) — attach the same fade-jump-fade ===
    // closeAllMega is defined later in this file, but we look it up via closure below.
    function attachMegaCardHandlers() {
      const megaCards = document.querySelectorAll('.luxe-header__mega-card');
      megaCards.forEach(card => {
        if (card.dataset.luxeFadeBound === 'true') return;
        card.dataset.luxeFadeBound = 'true';
        card.addEventListener('click', (e) => {
          // closeAllMega is defined below in this same script — reference it
          // via global getter so it doesn't matter if it's defined yet at attach time.
          const closer = window.__luxeCloseAllMega || null;
          if (performFadeJump(card, closer)) e.preventDefault();
        });
      });
    }
    // Expose performFadeJump so we can call it from outside this block if needed
    window.__luxePerformFadeJump = performFadeJump;
    attachMegaCardHandlers();

    // === Mega menu (hover under nav links with data-mega-trigger) ===
    const megaTriggers = document.querySelectorAll('[data-mega-trigger]');
    let megaCloseTimer = null;

    const closeAllMega = () => {
      document.querySelectorAll('[data-mega-panel]').forEach(p => {
        p.classList.remove('is-open');
        p.setAttribute('aria-hidden', 'true');
      });
      megaTriggers.forEach(t => t.classList.remove('is-active'));
    };
    // Expose for the mega card handler attached earlier
    window.__luxeCloseAllMega = closeAllMega;

    const openMega = (trigger) => {
      clearTimeout(megaCloseTimer);
      loadCardImages();
      closeAllMega();
      const panel = trigger.querySelector('[data-mega-panel]');
      if (panel) {
        panel.classList.add('is-open');
        panel.setAttribute('aria-hidden', 'false');
        trigger.classList.add('is-active');
      }
    };

    const closeMegaSoon = () => {
      clearTimeout(megaCloseTimer);
      megaCloseTimer = setTimeout(closeAllMega, 220);
    };

    megaTriggers.forEach(trigger => {
      trigger.addEventListener('mouseenter', () => openMega(trigger));
      trigger.addEventListener('mouseleave', closeMegaSoon);
      const link = trigger.querySelector('.luxe-header__nav-link');
      if (link) {
        link.addEventListener('click', (e) => {
          const panel = trigger.querySelector('[data-mega-panel]');
          const isOpen = panel && panel.classList.contains('is-open');
          if (isOpen) {
            // Allow link to navigate normally
          } else {
            e.preventDefault();
            openMega(trigger);
          }
        });
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeAllMega();
    });

    // === Brand mark migration on homepage ===
    const header = document.querySelector('.luxe-header');
    const brandmark = document.getElementById('luxeBrandmark');
    if (header && header.classList.contains('is-homepage') && brandmark) {
      const delay = parseInt(getComputedStyle(header).getPropertyValue('--lh-brand-migrate-delay')) || 2500;
      setTimeout(() => {
        header.classList.add('is-migrated');
      }, delay);
    }

    // === Brand mark click → scroll to top on homepage, normal link nav elsewhere ===
    if (brandmark) {
      const isHomepage = () => header && header.classList.contains('is-homepage');
      const handleBrandClick = (e) => {
        // Only intercept on homepage (so non-homepage pages still navigate to / normally)
        if (isHomepage()) {
          e.preventDefault();
          // Use instant scroll — smooth can be intercepted by sticky pins.
          // Manifesto state is NOT reset — if the user has already played through
          // the explosion, it stays in its played-out state when they scroll back down.
          window.scrollTo(0, 0);
          // Belt-and-suspenders: in case some sticky pin intercepts, force again
          // on the next frame.
          requestAnimationFrame(() => window.scrollTo(0, 0));
        }
        // On non-homepage: do nothing — the <a href="/"> handles navigation
      };
      brandmark.addEventListener('click', handleBrandClick);
      // touchend: only preventDefault on homepage. On other pages, this would
      // block the synthesized click → no navigation happens.
      brandmark.addEventListener('touchend', (e) => {
        if (isHomepage()) {
          e.preventDefault();
          handleBrandClick(e);
        }
        // On non-homepage: don't intervene, let touchend → click → navigate
      }, { passive: false });
    }

    // === Scroll-to-top on refresh is handled by the inline <script> at the top
    //     of the header markup. It runs synchronously on parse, before this
    //     deferred {% javascript %} block. Don't duplicate it here. ===

    // === Edge label visibility — hide when manifesto/experience is in view ===
    // The "UNLAWK · MMXXVI" vertical text on the left edge competes visually
    // with the manifesto reveal and product cells. Hide it when those sections
    // are in viewport, restore on hero / DP / footer.
    const edgeLabel = document.querySelector('.luxe-header__edge-label');
    const experienceSection = document.querySelector('.luxe-experience');
    if (edgeLabel && experienceSection) {
      const edgeObs = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            edgeLabel.classList.add('is-hidden');
          } else {
            edgeLabel.classList.remove('is-hidden');
          }
        });
      }, { threshold: 0.05 });  // hide as soon as 5% of experience is visible
      edgeObs.observe(experienceSection);
    }

    // === Cart count live update on cart change events ===
    // Accepts payloads with .count, .itemCount, or .item_count for robustness.
    document.addEventListener('cart:updated', (e) => {
      let count = null;
      if (e.detail) {
        if (typeof e.detail.count === 'number') count = e.detail.count;
        else if (typeof e.detail.itemCount === 'number') count = e.detail.itemCount;
        else if (typeof e.detail.item_count === 'number') count = e.detail.item_count;
      }
      // If no count in payload, fetch it ourselves
      if (count === null) {
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(r => r.json())
          .then(cart => updateCartCount(cart.item_count));
        return;
      }
      updateCartCount(count);
    });

    function updateCartCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        const newText = '(' + count + ')';
        if (el.textContent === newText) return;  // no change → no pulse
        el.textContent = newText;
        // Gold pulse animation so the increment is visible
        el.classList.remove('cart-count-pulse');
        // Force reflow to restart animation
        void el.offsetWidth;
        el.classList.add('cart-count-pulse');
      });
    }

    // === Collection selector targeting ===
    // Any element with [data-lce-target="<slug>"] will, on click:
    //   1. Set the collection-explorer's sessionStorage so the section opens to that slug
    //   2. Close the mobile side panel if open
    //   3. If on homepage: smooth-scroll to .lce + dispatch the change event
    //   4. If not on homepage: navigate to / and let the hash handler take over
    var COLLECTION_STORAGE_KEY = 'unlawk-active-collection';
    var COLLECTION_EVENT = 'unlawk-collection-change';

    document.addEventListener('click', function(e) {
      var trigger = e.target.closest('[data-lce-target]');
      if (!trigger) return;
      // Modifier keys → respect new-tab/etc
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var slug = trigger.getAttribute('data-lce-target');
      if (!slug) return;

      e.preventDefault();
      e.stopPropagation();

      // Persist the choice
      try { sessionStorage.setItem(COLLECTION_STORAGE_KEY, slug); } catch (err) {}

      // Close the side panel if it's open (it usually is on mobile when these are clicked)
      var sidePanel = document.querySelector('.luxe-header__menu');
      if (sidePanel && sidePanel.classList.contains('is-open')) {
        sidePanel.classList.remove('is-open');
        document.body.classList.remove('luxe-header-menu-open');
      }
      // Also close the menu via the existing toggle if available
      var burger = document.querySelector('.luxe-header__burger.is-open, [data-luxe-menu-toggle].is-open');
      if (burger) burger.classList.remove('is-open');

      var onHomepage = window.location.pathname === '/' || window.location.pathname === '';

      if (onHomepage) {
        // Same page: dispatch event with scroll flag; explorer handles both
        // the tab switch AND the scroll (with proper header offset).
        // Small delay so the side panel close animation completes first.
        setTimeout(function() {
          document.dispatchEvent(new CustomEvent(COLLECTION_EVENT, {
            detail: { slug: slug, source: 'header-link', scroll: true }
          }));
        }, 240);
      } else {
        // Other page: go home with hash, the explorer's hash handler picks it up
        window.location.href = '/#collection-' + slug;
      }
    }, { capture: false });
  })();

  } catch(e) { console.error(e); }
})();
})();
